var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/alert-dialog/AlertDialog.tsx
import { memo as memo8, useCallback as useCallback3 } from "react";
import {
  Action,
  Cancel,
  Content as Content2,
  Description,
  Portal as Portal2,
  Overlay as RadixOverlay,
  Title as RadixTitle,
  Root as Root2,
  Trigger as Trigger2
} from "@radix-ui/react-alert-dialog";
import { Shortcuts } from "utils";

// src/layout/Title.tsx
import { memo } from "react";
import Balancer from "react-wrap-balancer";
import { cx } from "utils";
import { jsx } from "react/jsx-runtime";
var Title = memo((props) => {
  const className = cx(
    !props.color && "text-high",
    props.truncate && "truncate flex-1",
    props.size === "huge" && "text-3xl sm:text-4xl flex-1 font-display tracking-tight font-medium leading-tight sm:leading-tight",
    props.size === "large" && "font-alt text-xl font-semibold leading-normal",
    !props.size && "font-medium leading-normal",
    props.size === "small" && "font-alt text-sm font-medium leading-normal",
    props.selectable && "select-text",
    !props.children ? "text-low" : props.color && `text-${props.color}`
  );
  if (props.size === "huge") {
    return /* @__PURE__ */ jsx(Balancer, { children: /* @__PURE__ */ jsx("h1", { className, children: props.children || "Untitled" }) });
  } else if (props.size === "large") {
    return /* @__PURE__ */ jsx("h2", { className, children: props.children || "Untitled" });
  } else if (props.size === "small") {
    return /* @__PURE__ */ jsx("h4", { className, children: props.children || "Untitled" });
  } else {
    return /* @__PURE__ */ jsx("h3", { className, children: props.children || "Untitled" });
  }
});
Title.displayName = "Title";

// src/layout/Text.tsx
import { memo as memo2 } from "react";
import { cx as cx2 } from "utils";
import { jsx as jsx2 } from "react/jsx-runtime";
var Text = memo2((props) => {
  const className = cx2(
    "w-full",
    props.variant === "lead" && "text-lg select-text",
    props.variant === "disclaimer" && "text-sm select-text",
    props.variant === "paragraph" && "leading-relaxed select-text",
    !props.variant && "text-sm",
    // No variant for UI elements
    props.center ? "text-center" : "text-left",
    !props.color && props.variant !== "disclaimer" && "text-med",
    !props.color && props.variant === "disclaimer" && "text-low",
    props.color && `text-${props.color}`
  );
  return /* @__PURE__ */ jsx2("p", { id: props.id, className, children: props.children });
});
Text.displayName = "Text";

// src/input/Button.tsx
import {
  forwardRef as forwardRef2,
  memo as memo7,
  useCallback as useCallback2
} from "react";
import { cx as cx7 } from "utils";

// src/display/Icon.tsx
import { memo as memo3 } from "react";
import { ICONS } from "icons";
import { cx as cx3 } from "utils";
import { jsx as jsx3 } from "react/jsx-runtime";
var Icon = memo3((props) => {
  return /* @__PURE__ */ jsx3(
    "div",
    {
      className: cx3(
        props.big ? "h-9 w-9" : props.small ? "h-5 w-5" : "h-6 w-6",
        // Our icons were designed as 24x24, so size 6 is optimal.
        `text-${props.color || "icon"}`,
        props.whiteOnGroupHover && "group-hover:text-on-color group-focus:text-on-color"
      ),
      children: ICONS[props.type]
    }
  );
});
Icon.displayName = "Icon";

// src/display/ShortcutLabel.tsx
import { memo as memo4 } from "react";
import { cx as cx4 } from "utils";
import { jsx as jsx4 } from "react/jsx-runtime";
var ShortcutLabel = memo4(
  (props) => {
    const overrides = {
      Enter: "\u21B5",
      Escape: "Esc"
    };
    return /* @__PURE__ */ jsx4(
      "span",
      {
        className: cx4(
          props.primary ? props.destructive ? "bg-red-dark text-on-color" : "bg-primary-dark text-on-color" : props.surface ? "bg-surface text-med" : "bg-background text-med",
          props.small ? "ml-2 w-[18px] pt-0.5 pb-px" : "ml-3 w-6 py-1",
          props.children === "Escape" && "w-auto px-1.5",
          // Override to provide room for escape
          "hidden flex-shrink-0 rounded-sm text-center text-xs font-semibold uppercase sm:inline-block"
        ),
        children: overrides[props.children] || props.children
      }
    );
  }
);
ShortcutLabel.displayName = "ShortcutLabel";

// src/display/Tooltip.tsx
import { memo as memo5 } from "react";
import {
  Content,
  Portal,
  Provider,
  Root,
  Trigger
} from "@radix-ui/react-tooltip";
import { cx as cx5 } from "utils";
import { Fragment, jsx as jsx5, jsxs } from "react/jsx-runtime";
var Tooltip = memo5((props) => {
  if (props.disabled) {
    return /* @__PURE__ */ jsx5(Fragment, { children: props.children });
  }
  return /* @__PURE__ */ jsx5(Provider, { children: /* @__PURE__ */ jsxs(Root, { children: [
    /* @__PURE__ */ jsx5(Trigger, { tabIndex: -1, className: "w-full cursor-default", children: props.children }),
    /* @__PURE__ */ jsx5(Portal, { children: /* @__PURE__ */ jsx5(
      Content,
      {
        sideOffset: 4,
        collisionPadding: 10,
        side: props.side || "bottom",
        className: cx5(
          "bg-elevated-transparent text-high z-50 max-w-xs rounded border py-1 px-2.5 text-sm font-medium shadow-lg backdrop-blur-sm",
          props.shortcutLabel ? "pr-2" : ""
        ),
        children: /* @__PURE__ */ jsxs("div", { className: "flex items-center space-x-3", children: [
          /* @__PURE__ */ jsx5("div", { children: props.text }),
          props.shortcutLabel && /* @__PURE__ */ jsx5(ShortcutLabel, { small: true, children: props.shortcutLabel })
        ] })
      }
    ) })
  ] }) });
});
Tooltip.displayName = "Tooltip";

// src/input/HeadlessButton.tsx
import {
  forwardRef,
  memo as memo6,
  useCallback
} from "react";
import { cx as cx6 } from "utils";
import { jsx as jsx6 } from "react/jsx-runtime";
var HeadlessButtonFn = forwardRef(
  (_a, ref) => {
    var _b = _a, {
      onClick,
      onKeyDown,
      type,
      className,
      children
    } = _b, rest = __objRest(_b, [
      "onClick",
      "onKeyDown",
      "type",
      "className",
      "children"
    ]);
    const handleKeyDown = useCallback(
      (e) => {
        if (e.key === "Enter") {
          onClick == null ? void 0 : onClick(e);
        }
        onKeyDown == null ? void 0 : onKeyDown(e);
      },
      [onClick, onKeyDown]
    );
    return /* @__PURE__ */ jsx6(
      "button",
      __spreadProps(__spreadValues({
        ref,
        type: type || "button",
        onKeyDown: handleKeyDown,
        className: cx6("cursor-default", className),
        onClick
      }, rest), {
        children
      })
    );
  }
);
HeadlessButtonFn.displayName = "HeadlessButton";
var HeadlessButton = memo6(HeadlessButtonFn);

// src/input/Button.tsx
import { Fragment as Fragment2, jsx as jsx7, jsxs as jsxs2 } from "react/jsx-runtime";
var ButtonFn = forwardRef2(
  (props, ref) => {
    const primary = props.forcePrimary || !props.clear && props.action.shortcut === "Enter";
    const className = cx7(
      "relative overflow-hidden flex items-center rounded font-semibold flex-shrink-0 whitespace-nowrap",
      !props.clear && !props.secondary && (primary ? props.action.destructive ? "shadow-sm bg-red text-on-color" : "shadow-sm bg-primary text-on-color" : props.action.destructive ? "bg-elevated text-red" : "bg-elevated text-high"),
      props.icon === true ? props.small ? "w-7 h-7 text-sm" : "w-9 h-9" : props.small ? `h-7 pl-2.5 ${props.action.shortcut ? "pr-1.5" : "pr-2.5"} text-sm` : `pl-4 ${props.action.shortcut ? "pr-3" : "pr-4"} h-9`,
      props.icon === true && "justify-center",
      !!props.action.disabled && "opacity-40",
      // Only used when explicitly disabled, not when overlay is set
      !props.overlay && primary ? "active:brightness-95" : "active:brightness-[0.98] dark:active:brightness-95",
      props.secondary && "bg-background text-high",
      props.clear && "text-high",
      props.clear && !props.action.disabled && "hover:bg-background active:bg-background"
    );
    const handleKeyDown = useCallback2((e) => {
      if (e.key === "Escape") {
        e.currentTarget.blur();
      }
    }, []);
    return /* @__PURE__ */ jsx7(
      Tooltip,
      {
        disabled: props.icon !== true,
        text: props.action.title,
        shortcutLabel: props.action.shortcut,
        children: /* @__PURE__ */ jsxs2(
          HeadlessButton,
          {
            ref,
            className,
            disabled: !!props.overlay || !!props.action.disabled,
            type: props.type || "button",
            onClick: props.type === "submit" ? void 0 : props.action.onAction,
            onKeyDown: handleKeyDown,
            children: [
              props.icon === true && props.action.icon ? /* @__PURE__ */ jsx7(Icon, { type: props.action.icon }) : /* @__PURE__ */ jsxs2(Fragment2, { children: [
                /* @__PURE__ */ jsx7("span", { children: props.action.title }),
                props.action.shortcut && /* @__PURE__ */ jsx7(
                  ShortcutLabel,
                  {
                    small: props.small,
                    destructive: props.action.destructive,
                    primary,
                    children: props.action.shortcut
                  }
                ),
                props.icon === "right" && props.action.icon && /* @__PURE__ */ jsx7("div", { className: "ml-2", children: /* @__PURE__ */ jsx7(Icon, { type: props.action.icon, small: true }) })
              ] }),
              props.overlay && /* @__PURE__ */ jsx7("div", { className: "bg-primary pointer-events-none absolute inset-0 z-10 flex items-center justify-center", children: props.overlay })
            ]
          }
        )
      }
    );
  }
);
ButtonFn.displayName = "Button";
var Button = memo7(ButtonFn);

// src/alert-dialog/AlertDialog.tsx
import { jsx as jsx8, jsxs as jsxs3 } from "react/jsx-runtime";
var AlertDialog = memo8(
  (_a) => {
    var _b = _a, { onOpenChange, onConfirm } = _b, props = __objRest(_b, ["onOpenChange", "onConfirm"]);
    const prevent = useCallback3((e) => {
      e.preventDefault();
    }, []);
    const closeDialog = useCallback3(() => {
      onOpenChange == null ? void 0 : onOpenChange(false);
    }, [onOpenChange]);
    return /* @__PURE__ */ jsxs3(Root2, { open: props.open, onOpenChange, children: [
      props.children && /* @__PURE__ */ jsx8(Trigger2, { children: props.children }),
      /* @__PURE__ */ jsx8(
        Shortcuts,
        {
          actions: {
            confirm: {
              onAction: () => {
                onConfirm == null ? void 0 : onConfirm();
              },
              shortcut: "Enter",
              title: "Confirm"
            }
          }
        }
      ),
      /* @__PURE__ */ jsxs3(Portal2, { children: [
        /* @__PURE__ */ jsx8(RadixOverlay, { className: "fixed inset-0 z-40 brightness-75 backdrop-blur-none" }),
        /* @__PURE__ */ jsx8(
          Content2,
          {
            onOpenAutoFocus: prevent,
            className: "focus-ring-none fixed inset-0 z-50 flex items-center justify-center",
            children: /* @__PURE__ */ jsxs3("div", { className: "bg-surface flex w-full max-w-lg flex-col rounded-lg border p-6 shadow-lg", children: [
              /* @__PURE__ */ jsx8(RadixTitle, { children: /* @__PURE__ */ jsx8(Title, { children: props.title }) }),
              /* @__PURE__ */ jsx8(Description, { className: "mt-2 mb-6", children: /* @__PURE__ */ jsx8(Text, { children: props.description }) }),
              /* @__PURE__ */ jsxs3("div", { className: "flex justify-end space-x-3", children: [
                /* @__PURE__ */ jsx8(Cancel, { tabIndex: -1, children: /* @__PURE__ */ jsx8(
                  Button,
                  {
                    action: {
                      onAction: closeDialog,
                      shortcut: "Escape",
                      title: "Cancel"
                    }
                  }
                ) }),
                /* @__PURE__ */ jsx8(Action, { tabIndex: -1, children: /* @__PURE__ */ jsx8(
                  Button,
                  {
                    action: {
                      destructive: props.destructive,
                      onAction: onConfirm,
                      shortcut: "Enter",
                      title: props.confirmLabel
                    }
                  }
                ) })
              ] })
            ] })
          }
        )
      ] })
    ] });
  }
);
AlertDialog.displayName = "AlertDialog";

// src/context-menu/ContextMenu.tsx
import {
  Content as Content3,
  Group,
  Item,
  Root as Root3,
  Separator,
  Trigger as Trigger3
} from "@radix-ui/react-context-menu";
import React, { memo as memo10, useState } from "react";

// src/menu/MenuItem.tsx
import { memo as memo9 } from "react";
import { cx as cx8 } from "utils";
import { jsx as jsx9, jsxs as jsxs4 } from "react/jsx-runtime";
var MenuItem = memo9(
  ({ action }) => {
    return /* @__PURE__ */ jsxs4(
      "div",
      {
        className: cx8(
          "flex cursor-default items-center space-x-2.5 rounded px-2.5 py-1 text-sm font-medium",
          action.destructive ? "text-red group-hover:bg-red group-focus:bg-red group-active:bg-red-dark" : "text-high group-hover:bg-primary group-focus:bg-primary group-active:bg-primary-dark",
          action.disabled ? "opacity-50" : "group-hover:text-on-color group-focus:text-on-color"
        ),
        children: [
          action.icon && /* @__PURE__ */ jsx9(
            Icon,
            {
              small: true,
              whiteOnGroupHover: true,
              color: action.destructive ? "red" : void 0,
              type: action.icon
            }
          ),
          /* @__PURE__ */ jsx9("div", { children: action.title })
        ]
      }
    );
  }
);
MenuItem.displayName = "MenuItem";

// src/context-menu/ContextMenu.tsx
import { jsx as jsx10, jsxs as jsxs5 } from "react/jsx-runtime";
var ContextMenu = memo10(
  (props) => {
    const [isOpen, setIsOpen] = useState(false);
    return /* @__PURE__ */ jsxs5(Root3, { onOpenChange: setIsOpen, children: [
      /* @__PURE__ */ jsx10(Trigger3, { disabled: props.disabled, className: "cursor-default rounded", children: typeof props.children === "function" ? props.children(isOpen) : props.children }),
      /* @__PURE__ */ jsx10(
        Content3,
        {
          className: "bg-elevated-transparent focus-ring-none z-50 rounded-lg border p-1 shadow-lg backdrop-blur-sm",
          style: { minWidth: 200 },
          loop: true,
          children: props.actionList.map((group, i) => /* @__PURE__ */ jsxs5(React.Fragment, { children: [
            i > 0 && /* @__PURE__ */ jsx10(Separator, { className: "my-2 border-b" }),
            /* @__PURE__ */ jsxs5(Group, { children: [
              group.groupTitle && /* @__PURE__ */ jsx10(
                "div",
                {
                  className: `text-med px-2.5 pb-1.5 text-xs font-medium ${i > 0 ? "pt-0" : "pt-1.5"}`,
                  children: group.groupTitle
                }
              ),
              group.actions.map((action, i2) => /* @__PURE__ */ jsx10(
                Item,
                {
                  onSelect: action.onAction,
                  className: "focus-ring-none group",
                  children: /* @__PURE__ */ jsx10(MenuItem, { action })
                },
                i2
              ))
            ] })
          ] }, i))
        }
      )
    ] });
  }
);
ContextMenu.displayName = "ContextMenu";

// src/display/Avatar.tsx
import { memo as memo11 } from "react";
import { cx as cx9 } from "utils";
import { jsx as jsx11 } from "react/jsx-runtime";
var Avatar = memo11((props) => {
  var _a;
  return /* @__PURE__ */ jsx11(
    "div",
    {
      className: cx9(
        "bg-gray text-on-color relative flex h-9 w-9 items-center justify-center rounded-full font-medium",
        props.clickable && "shadow-sm active:brightness-95"
      ),
      children: (_a = props.name) == null ? void 0 : _a[0]
    }
  );
});
Avatar.displayName = "Avatar";

// src/display/Badge.tsx
import { memo as memo12 } from "react";
import { jsx as jsx12 } from "react/jsx-runtime";
var Badge = memo12((props) => {
  const colorWithDefault = props.color || "gray";
  return /* @__PURE__ */ jsx12(
    "div",
    {
      className: `bg-${colorWithDefault}-bright text-${colorWithDefault} flex h-6 items-center justify-center truncate rounded-full px-2.5 text-sm font-medium`,
      children: props.children
    }
  );
});
Badge.displayName = "Badge";

// src/display/Card.tsx
import { memo as memo13 } from "react";
import { cx as cx10 } from "utils";
import { jsx as jsx13 } from "react/jsx-runtime";
var Card = memo13((props) => {
  const className = cx10("bg-elevated rounded-lg px-3 p-2 w-full shadow-sm");
  return /* @__PURE__ */ jsx13("div", { className, children: props.children });
});
Card.displayName = "Card";

// src/display/ImageLike.tsx
import { memo as memo14 } from "react";
import { cx as cx11 } from "utils";
import { Fragment as Fragment3, jsx as jsx14 } from "react/jsx-runtime";
var ImageLike = memo14(
  (props) => {
    return props.image.icon ? /* @__PURE__ */ jsx14(
      "div",
      {
        className: cx11(
          "flex flex-shrink-0 items-center justify-center rounded",
          props.size || "h-9 w-9"
        ),
        children: /* @__PURE__ */ jsx14(Icon, { type: props.image.icon })
      }
    ) : /* @__PURE__ */ jsx14(Fragment3, { children: props.image });
  }
);
ImageLike.displayName = "ImageLike";

// src/display/NotificationBar.tsx
import { memo as memo15, useEffect, useState as useState2 } from "react";
import { statusToColor } from "utils";
import { jsx as jsx15, jsxs as jsxs6 } from "react/jsx-runtime";
var NotificationBar = memo15(
  (props) => {
    const [notificationCache, setNotificationCache] = useState2(void 0);
    const [isAnimatingOut, setIsAnimatingOut] = useState2(false);
    useEffect(() => {
      let timeout;
      if (props.status && props.message) {
        setIsAnimatingOut(false);
        setNotificationCache({
          message: props.message,
          status: props.status
        });
      } else {
        setIsAnimatingOut(true);
        timeout = setTimeout(() => {
          setNotificationCache(void 0);
          setIsAnimatingOut(false);
        }, 500);
      }
      return () => {
        clearTimeout(timeout);
      };
    }, [props.status, props.message]);
    if (!(notificationCache == null ? void 0 : notificationCache.status) || !(notificationCache == null ? void 0 : notificationCache.message))
      return null;
    const color = statusToColor(notificationCache.status);
    return /* @__PURE__ */ jsxs6("div", { className: "relative -m-3 flex items-center overflow-hidden p-3", children: [
      /* @__PURE__ */ jsx15(
        "div",
        {
          className: `${isAnimatingOut ? "animate-notification-bg-out" : "animate-notification-bg"} transition-all bg-${color}-bright absolute -left-4 h-14 w-14 rounded-full opacity-50`
        }
      ),
      /* @__PURE__ */ jsx15(
        "div",
        {
          className: `${isAnimatingOut ? "animate-notification-dot-out" : "animate-notification-dot"} bg-${color} relative mr-3 h-2 w-2 rounded-full`
        }
      ),
      /* @__PURE__ */ jsx15(
        "div",
        {
          className: `${isAnimatingOut ? "animate-notification-text-out" : "animate-notification-text"} relative`,
          children: /* @__PURE__ */ jsx15(Text, { color, children: notificationCache.message })
        }
      )
    ] });
  }
);
NotificationBar.displayName = "NotificationBar";

// src/display/Spinner.tsx
import { memo as memo16 } from "react";
import { cx as cx12 } from "utils";
import { jsx as jsx16, jsxs as jsxs7 } from "react/jsx-runtime";
var Spinner = memo16((props) => {
  return /* @__PURE__ */ jsxs7(
    "svg",
    {
      className: cx12(
        "text-icon animate-spin",
        props.muted && "opacity-20",
        props.big ? "h-8 w-8" : "h-5 w-5"
      ),
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ jsx16(
          "circle",
          {
            className: "opacity-25",
            cx: "12",
            cy: "12",
            r: "10",
            stroke: "currentColor",
            strokeWidth: "4"
          }
        ),
        /* @__PURE__ */ jsx16(
          "path",
          {
            className: "opacity-75",
            fill: "currentColor",
            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          }
        )
      ]
    }
  );
});
Spinner.displayName = "Spinner";

// src/dropdown-menu/DropdownMenu.tsx
import React2, {
  forwardRef as forwardRef3,
  memo as memo17,
  useCallback as useCallback4,
  useImperativeHandle,
  useState as useState3
} from "react";
import {
  Content as Content4,
  Group as Group2,
  Item as Item2,
  Root as Root4,
  Separator as Separator2,
  Trigger as Trigger4
} from "@radix-ui/react-dropdown-menu";
import { jsx as jsx17, jsxs as jsxs8 } from "react/jsx-runtime";
var DropdownMenuFn = forwardRef3(
  (props, ref) => {
    const [isOpen, setIsOpen] = useState3(false);
    useImperativeHandle(ref, () => ({
      close: () => {
        setIsOpen(false);
      },
      open: () => {
        setIsOpen(true);
      }
    }));
    const prevent = useCallback4((e) => {
      e.preventDefault();
    }, []);
    return /* @__PURE__ */ jsxs8(Root4, { modal: false, open: isOpen, onOpenChange: setIsOpen, children: [
      /* @__PURE__ */ jsx17(Trigger4, { disabled: props.disabled, className: "cursor-default rounded", children: typeof props.children === "function" ? props.children(isOpen) : props.children }),
      /* @__PURE__ */ jsx17(
        Content4,
        {
          sideOffset: 6,
          onCloseAutoFocus: prevent,
          side: props.side,
          align: props.align,
          className: "bg-elevated-transparent focus-ring-none z-50 rounded-lg border p-1 shadow-lg backdrop-blur-sm",
          style: { minWidth: 200 },
          loop: true,
          children: props.actionList.map((group, i) => /* @__PURE__ */ jsxs8(React2.Fragment, { children: [
            i > 0 && /* @__PURE__ */ jsx17(Separator2, { className: "my-2 border-b" }),
            /* @__PURE__ */ jsxs8(Group2, { children: [
              group.groupTitle && /* @__PURE__ */ jsx17(
                "div",
                {
                  className: `text-med px-2.5 pb-1.5 text-xs font-medium ${i > 0 ? "pt-0" : "pt-1.5"}`,
                  children: group.groupTitle
                }
              ),
              group.actions.map((action, i2) => /* @__PURE__ */ jsx17(
                Item2,
                {
                  onSelect: action.onAction,
                  className: "focus-ring-none group",
                  children: /* @__PURE__ */ jsx17(MenuItem, { action })
                },
                i2
              ))
            ] })
          ] }, i))
        }
      )
    ] });
  }
);
DropdownMenuFn.displayName = "DropdownMenu";
var DropdownMenu = memo17(DropdownMenuFn);

// src/form/Field.tsx
import { forwardRef as forwardRef5, memo as memo19 } from "react";
import { Field as FormikField } from "formik";

// src/input/Input.tsx
import {
  forwardRef as forwardRef4,
  memo as memo18,
  useCallback as useCallback5
} from "react";
import { cx as cx13 } from "utils";
import { jsx as jsx18, jsxs as jsxs9 } from "react/jsx-runtime";
function InputFn(_a, ref) {
  var _b = _a, { onChange } = _b, props = __objRest(_b, ["onChange"]);
  var _a2, _b2, _c, _d, _e;
  const handleChange = useCallback5(
    (e) => {
      onChange == null ? void 0 : onChange(e.target.value, e);
    },
    [onChange]
  );
  const name = (_a2 = props.field) == null ? void 0 : _a2.name;
  const touched = props.form && props.form.touched[name];
  const error = touched && ((_b2 = props.form) == null ? void 0 : _b2.errors[name]);
  const handleKeyDown = useCallback5((e) => {
    if (e.key === "Escape") {
      e.currentTarget.blur();
    }
  }, []);
  return /* @__PURE__ */ jsxs9("div", { className: "relative w-full", children: [
    /* @__PURE__ */ jsx18(
      "input",
      __spreadValues({
        ref,
        id: props.id,
        value: props.value,
        disabled: props.disabled,
        onChange: handleChange,
        "aria-describedby": props.describedById,
        onKeyDown: handleKeyDown,
        type: props.type || "text",
        className: cx13(
          "text-high focus-ring-none focus:border-primary peer h-9 w-full min-w-0 resize-none appearance-none rounded border bg-transparent pl-3",
          "disabled:opacity-40",
          error || ((_c = props.action) == null ? void 0 : _c.shortcut) ? "pr-9 focus:pr-3" : "pr-3",
          error && "border-orange focus:border-border"
        ),
        placeholder: props.placeholder
      }, props.field)
    ),
    ((_d = props.action) == null ? void 0 : _d.shortcut) && /* @__PURE__ */ jsx18("div", { className: "pointer-events-none absolute top-0 right-0 my-px py-1 px-2 peer-focus:hidden", children: /* @__PURE__ */ jsx18(ShortcutLabel, { children: (_e = props.action) == null ? void 0 : _e.shortcut }) }),
    error && /* @__PURE__ */ jsx18("div", { className: "pointer-events-none absolute top-0 right-0 p-1.5", children: /* @__PURE__ */ jsx18(Icon, { type: "warning", color: "orange" }) })
  ] });
}
var Input = memo18(forwardRef4(InputFn));

// src/form/Field.tsx
import { jsx as jsx19 } from "react/jsx-runtime";
function FieldFn(props, ref) {
  return /* @__PURE__ */ jsx19(FormikField, { name: props.name, children: ({
    field,
    form
  }) => {
    return /* @__PURE__ */ jsx19(
      Input,
      __spreadValues({
        value: "",
        ref,
        field,
        form
      }, props)
    );
  } });
}
var Field = memo19(forwardRef5(FieldFn));

// src/form/Form.tsx
import { memo as memo20 } from "react";
import { Formik, Form as FormikForm } from "formik";
import { toFormikValidationSchema } from "zod-formik-adapter";
import { jsx as jsx20 } from "react/jsx-runtime";
function FormFn(props) {
  return /* @__PURE__ */ jsx20(
    Formik,
    {
      initialValues: props.initialValues,
      onSubmit: props.onSubmit,
      validationSchema: toFormikValidationSchema(props.schema),
      children: /* @__PURE__ */ jsx20(FormikForm, { className: "w-full", children: props.children })
    }
  );
}
var Form = memo20(FormFn);

// src/form/LeadForm.tsx
import { memo as memo22, useCallback as useCallback6, useState as useState4 } from "react";
import { z } from "zod";

// src/input/Label.tsx
import { memo as memo21 } from "react";
import { Fragment as Fragment4, jsx as jsx21, jsxs as jsxs10 } from "react/jsx-runtime";
var Label = memo21((props) => {
  return /* @__PURE__ */ jsxs10(Fragment4, { children: [
    /* @__PURE__ */ jsx21(
      "label",
      {
        className: "text-med block px-1 pb-1 text-sm font-medium",
        htmlFor: props.for,
        children: props.title
      }
    ),
    props.description && /* @__PURE__ */ jsx21(Text, { id: props.for + "-desc", children: props.description }),
    props.children(props.for, props.for + "-desc")
  ] });
});
Label.displayName = "Label";

// src/form/LeadForm.tsx
import { jsx as jsx22, jsxs as jsxs11 } from "react/jsx-runtime";
var leadFormSchema = z.object({
  email: z.string().email(),
  firstName: z.string().optional()
});
var LeadForm = memo22(
  ({ onSubmit }) => {
    const [isSubscribed, setIsSubscribed] = useState4(false);
    const [error, setError] = useState4("");
    const handleSubmit = useCallback6(
      (data) => {
        setError("");
        const d = data;
        if (!d.firstName)
          delete d.firstName;
        void onSubmit(d).then(() => {
          setIsSubscribed(true);
        }).catch((err) => {
          setError(err.message || "Unknown error");
        });
      },
      [onSubmit]
    );
    return /* @__PURE__ */ jsx22("div", { className: "bg-elevated w-full rounded-lg p-3.5 shadow-sm", children: isSubscribed ? /* @__PURE__ */ jsx22("div", { className: "flex h-[196px] items-center justify-center sm:h-[60px]", children: /* @__PURE__ */ jsx22(Icon, { type: "checkCircle", color: "green", big: true }) }) : /* @__PURE__ */ jsxs11(
      Form,
      {
        initialValues: { email: "", firstName: "" },
        schema: leadFormSchema,
        onSubmit: handleSubmit,
        children: [
          /* @__PURE__ */ jsxs11("div", { className: "items-end space-y-5 sm:flex sm:space-y-0 sm:space-x-3", children: [
            /* @__PURE__ */ jsx22("div", { className: "flex-shrink-0 sm:w-28", children: /* @__PURE__ */ jsx22(Label, { title: "First name", for: "firstName", children: (id) => /* @__PURE__ */ jsx22(Field, { id, name: "firstName", placeholder: "Pedro" }) }) }),
            /* @__PURE__ */ jsx22("div", { className: "flex-1", children: /* @__PURE__ */ jsx22(Label, { title: "Email address", for: "email", children: (id) => /* @__PURE__ */ jsx22(
              Field,
              {
                id,
                name: "email",
                type: "email",
                placeholder: "pedro@example.com"
              }
            ) }) }),
            /* @__PURE__ */ jsx22(
              Button,
              {
                secondary: true,
                type: "submit",
                action: {
                  title: "Notify me"
                }
              }
            )
          ] }),
          error && /* @__PURE__ */ jsxs11("div", { className: "text-red bg-red-bright mt-4 rounded px-3 py-2 text-sm", children: [
            /* @__PURE__ */ jsx22("span", { className: "font-semibold", children: "Something went wrong." }),
            " ",
            'Sorry about that! Please try again or contact us if this keeps happening, so we can fix it right away. This is the error message: "',
            error,
            '".'
          ] })
        ]
      }
    ) });
  }
);
LeadForm.displayName = "LeadForm";

// src/inline/Code.tsx
import { memo as memo23 } from "react";
import { jsx as jsx23 } from "react/jsx-runtime";
var Code = memo23((props) => {
  return /* @__PURE__ */ jsx23("span", { className: "bg-background -mx-0.5 rounded px-0.5 font-mono text-sm", children: props.children });
});
Code.displayName = "Code";

// src/inline/Highlight.tsx
import { memo as memo24 } from "react";
import { jsx as jsx24 } from "react/jsx-runtime";
var Highlight = memo24(
  (props) => {
    return /* @__PURE__ */ jsx24("span", { className: "bg-yellow-bright text-brown -mx-0.5 rounded px-0.5", children: props.children });
  }
);
Highlight.displayName = "Highlight";

// src/inline/Link.tsx
import { memo as memo25 } from "react";
import NextLink from "next/link";
import { jsx as jsx25 } from "react/jsx-runtime";
var Link = memo25((props) => {
  var _a;
  const defaultBlank = props.blank === void 0 ? (_a = props.href) == null ? void 0 : _a.startsWith("http") : props.blank;
  const className = "border-b text-high hover:brightness-105 cursor-pointer focus-ring-none focus:border-b-primary";
  return props.href ? /* @__PURE__ */ jsx25(
    NextLink,
    {
      className,
      target: defaultBlank ? "_blank" : void 0,
      href: props.href,
      children: props.children
    }
  ) : /* @__PURE__ */ jsx25(HeadlessButton, { onClick: props.onClick, className, children: props.children });
});
Link.displayName = "Link";

// src/input/InputTitle.tsx
import { memo as memo27 } from "react";

// src/input/InputOnClick.tsx
import {
  memo as memo26,
  useCallback as useCallback7
} from "react";
import { cx as cx14 } from "utils";
import { jsx as jsx26 } from "react/jsx-runtime";
var InputOnClick = memo26(
  (_a) => {
    var _b = _a, { onActiveChange } = _b, props = __objRest(_b, ["onActiveChange"]);
    const handleInputBlur = useCallback7(
      (e) => {
        onActiveChange == null ? void 0 : onActiveChange(e.target.value);
      },
      [onActiveChange]
    );
    const handleButtonClick = useCallback7(() => {
      onActiveChange == null ? void 0 : onActiveChange(void 0);
    }, [onActiveChange]);
    const prevent = useCallback7((e) => {
      e.preventDefault();
    }, []);
    const handleKeyDown = useCallback7(
      (e) => {
        if (e.key === "Escape") {
          onActiveChange == null ? void 0 : onActiveChange(void 0);
        } else if (e.key === "Enter") {
          e.currentTarget.blur();
        }
      },
      [onActiveChange]
    );
    return props.isActive ? /* @__PURE__ */ jsx26("form", { spellCheck: false, onSubmit: prevent, className: "w-full", children: /* @__PURE__ */ jsx26(
      "input",
      {
        onBlur: handleInputBlur,
        onKeyDown: handleKeyDown,
        className: cx14(
          props.classNameForInput,
          "bg-background h-9 w-full px-2"
        ),
        defaultValue: props.defaultValue,
        placeholder: "Untitled",
        autoFocus: true
      }
    ) }) : /* @__PURE__ */ jsx26(
      HeadlessButton,
      {
        onClick: handleButtonClick,
        className: cx14(
          "h-9 w-full rounded px-2 text-left",
          onActiveChange && "hover:bg-elevated"
        ),
        children: props.children
      }
    );
  }
);
InputOnClick.displayName = "InputOnClick";

// src/input/InputTitle.tsx
import { jsx as jsx27 } from "react/jsx-runtime";
var InputTitle = memo27(
  (props) => {
    return /* @__PURE__ */ jsx27(
      InputOnClick,
      {
        isActive: props.isActive,
        defaultValue: props.value,
        onActiveChange: props.onActiveChange,
        classNameForInput: "text-lg font-semibold text-high truncate flex-1 focus-ring-none appearance-none",
        children: /* @__PURE__ */ jsx27(Title, { children: props.value })
      }
    );
  }
);
InputTitle.displayName = "InputTitle";

// src/jeroen/JeroenAvatar.tsx
import Image from "next/image";
import { memo as memo28 } from "react";
import { cx as cx15 } from "utils";
import { jsx as jsx28 } from "react/jsx-runtime";
var AVATAR_BASE64 = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAMCAgMCAgMDAgMDAwMDBAcFBAQEBAkGBwUHCgkLCwoJCgoMDREODAwQDAoKDhQPEBESExMTCw4UFhQSFhESExL/2wBDAQMDAwQEBAgFBQgSDAoMEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhISEhL/wgARCAHAAcADAREAAhEBAxEB/8QAHQAAAQQDAQEAAAAAAAAAAAAAAwIEBQYAAQcICf/EABsBAAIDAQEBAAAAAAAAAAAAAAECAAMEBQYH/9oADAMBAAIQAxAAAAD6fSakyTJMkyHIckyHJMkyTJMk3JkmpMkyTcmpNyakjhORpRSnoBYEEheKgRCSBKs5Urat7dUUAbsquaZzoNV2JyaQ1XqRiIxoS1k0ZzVDsCI1wuW8bqXDDciLqsk1JkmSZJkbJNw6gyHJMkyTcmSZJkmSZJkmSakj5OWviqF2UbgD1tGhmQcZYRQdwFwOkOqTRZdcyWEEVXY6RtIyQSknRl1OaM7pY5iklrllx0BwwyRF1WSakyTJMhyHcmSahyTJMgyHcmSZJkGQ5Jkm5EyR4nLbMtJux7DiurZOCFBrYQV6V3QbCQ12acJVzSZVaURQZ1WVBtLDBlVuRGKrO6S5aKqa2PLtsrcMNyDuqyTJNSbh1BuHIckyHJNSbkyDIckyTJMk3JkmSakjhOSrTSHqFIiFDjBEWxVR28LWUg5GSjaaFrZUddZUYepliKRzAkkVW5VJ6GdOpEa4XV3ro0OGG5EXVakyTJMkyTIckyHJMh3BqHINw5JkmSZJkmSZJkjATnirQ78Vgz73dOmi7OZmjKFnIaMjlKjV3FWmYz7ILVhwLgsOgwO6WYp2HKpJCStiKzuomMWstce6aEcNMMHbVqTJMkyTUmRtyZJuHINw5BkmSbh1JuTUG4dSJkTI0RqOscK9krspQar20Wuq5jm1QBVh0+QLRmUHtfI7R7lrGvGUJFXZ9vSoM4qOApjKRyhiJDK7mlnRG1Nrllz0BwwySHsq1DohIOockyRUhoXZhpNybk1JuDUO5MkyDUOpG0jGq1EgKLXamuc3oRlqtceqxbckBk1Q9d9s6HOg0uVS2zFMjjVnidOSt7ucuVJJFi0iWzVdiwTKVVOZw4pLpwus221b1vpcuNyeU6MrKytuVCwEZowSyaMu5v6+b5hiaTINw5BkOSZBkOSakbA8+5vUf30QXF6VO5vTlNeXonU5cjdUwzaalzt8PVdu+rz7V0JDNb3zVy67n0y+zLaNmKH1ZYPq8VBXVFoEvIhIpJCulltHFTHIKVtTG7bK3LDJPJueupasGrEIGUwSSVTMOr8t1nNtvb2PDFSLkLISTUm5Mk1JkkUjc+5PVpHL6dF5HT5jdf6Lu5nR+nzasujzXzvQdiz47v0efWCzCt5al7JdmaB+UZ9tKus64uK897ht+hzzgxN2aQpua2U4QtCsRxW5yFIbQXuV8cMMk8rJmpOjDpxsxyQQx2skXJjDU3WMWyIZ6rT4sujPIGEkyDJMhTJHI9VxbOF+R9Rz/J0eVbxO2UdTSrzZ0pLZ7e+86dS18+V00TFY51i6L2teKX7KFc83WlcN3ZrOf3vZyHGzKK2ms35AuhVO62WC5EPApWtji87KnLDJPMFvH5foyIaOpHLB5Fkba5Qw0fBYtG2WCBM59XXs/TszF1AqTUOSCgCDD03818p6LkfE9Bxjea1qzgdOfdbn955Gu40W8e3TqXKvLdTDU6u/LzpTp5qRRq5iujmF1jSWesqeXf8AbzQdDBEa8RACkrpYshay4YLhtjrfN1LlhknlZ+XzbTiK82Gcsr6I/dJW5XCnYJoxCRKLVm3dAo6Vqju5FQZDuAcOpKvzuhUuF16ji6Mt0sPkfF2OXb8xmT0zkfyzskxm0CMrerN3vkbenYlu+7FxG3RAJZR7bI5bOy5qfWHV82y6OGD6POG1JlJFKwx6WO4Wss8sul4ckbk8rWcrml+UpjghcLlq35WTcOA+GbWzanUa05tXU13WQl3CuDUm4dSR6NzHzXouX8vsejfXeQg82zz/AOc9NxEXSMr491c9Q157xy+pHW1dfyGAssja7qntzRdtUnS9oy3V21ei49Hou7jXPp8wm7Ax2c88VaNpbHKg7Aim0xrtoRywyTy5dxuV35HDQ0hyrpllmSWtVwToNoHSsMNZMu/qGbpWhmeSKg1JuTUkbTb598T7KX6mTpHR5tZw7+H8zrUWvTxnoVwFhAZZMe5yrnrZhYrK2mL0ZGr1T+W4wNR1Zbfi6PUso7lp5F27HFP0OasLqqxKstColpi09E3ZLZvzOHXBPJw53Or8m2horpw4MkQsvaHEGNNAqeIAuWXd0ino2cs7gVJkmQ5JBZ7/ACV5b2PrL0/k6Vx+xz3l9QWpaXm1cXTo1tn6JzN81VGjpJmtur1u23nm/PTNnLKVcLIPRks2bZa6rr1VV3rbw+h9bhp00LQrQkhUGlqnt+/I+trWZknl88fll+UbE8j2xXqCTtWUaOYUQ6U7W0atY6NXVq99mJeEKkyHUGSRtdnn3hel9B9vzkfRo57y+5Vs2yo5tPMM3RsGDdNiuZlWOgITskct3MG28Z6eCD1YivWorPVXSVdpK7Ouri753/IPrshjHSlyY8DXW9Je6o5CREw+Wm5PMNGEYjgly0kispZXMWK4j7AXCsOgG0Zd3Q6elaCXZVUOSahyBAPPMfUut+CLz6ua8zuwOTTC0386zdG1ZbCAyBreStAZzEaqeap0uI9NK3qwrtrjmqcK87XYiuy/Gn1J3/BEdDKztY8MfBuiaK5W6shAVLVLPLjcnl+nG3EeukjA/dXwMw8cGbh3GUCkS4Z9vUK91kaOyu5MhyHIdCRtdkJl2Ujmdmt0bkmN67Kfj2s899magwLoouhkqWKPyubeKdGROjIK2tUWLZJNLbbTb6I6Xmul9Xz5mrxYVWciPUa9aBIMugQK1czauI9byXG7KAqZGxJl6pEiSsEwxdxtqyJNRkqbPk39So6NneOiqpMkwNowQPE+B6PiOHoyFWjoee4tyMqrRhkiDeGKKrg8mjVcihbwe7fzndni7M6La0MNLHcstdVnsH03zuYvzGM2kUrOlj5Xud0a12QFGlUKSeNbvK8suytiHbJK3LIlX8Ey0eh8abMSp2Rc8fR6PVvsrR0VVJqTI2pEKfO3m/Wea8XUiKOh3rGs3F5I+mi9DE6urstV13SXGmrMl5Ky3rs8+Tqcz6mJhfnd1vF6s7pWk67Oh6sXp/0PhCsHAG1OKx1MsrXm5GddtUz6yw7jcz3+Q5ZdkbiGsDx6n7iQgmL1c12aJwNiOkS1Z93V691leOiqpMk1DkKQeV8zt+auJ6Gs1busaufLcvoUXh9Xg/bpuxydBzENjDjXg0SFQTVdzGrf596tLR6UWoKyp+XcV2dv6HA7j2vKKVnJAanyMqppJ5d7q26PTsvSIGIXp3U8Jye7INS4srdWVObq5QiZsj5WwnQbYZIFuxdTpNPRs1kdRdSBDak3IsEKW8G8/wCua6aEUdCG4fTo2TXyXq5jbOfO4Onduc/REwhawttektpVOrzjtuhtObboQx4w0X9W9vxN86fE0jnaZW2Mx0JjJUhUtg8nRa5tjywc/wBvh+VaMmgHrru2t61L15OtH8bcioSq6TLnj6HUE3WN45KtQ1cpsZKzppaHWJo2UjL17js5nnvzvuUc4iRqXa0sKZipRqyM986c5CN2NW8urzTo2MGkiGu1cofQy2/XzfR3pvCz+jCVgUFYZcY6FwxWSRbGOPpjo2Hac46Pg+MPlWC6tU1tL6zPLPXNtY9DaBUIdLcV7Rk6HUq+hZnDkhkG59k0QheyOMw9Tm/nPUz3UxQ+ffAZNEYGXlLvo4m1yuojqJrK5Mlp1JQY+m7i+br2mlLklDiq3i3bSy+k8p2ru+U0yqhIYpbCAuIXFhWGUtmZtzim4oPJNviOQW5VWgjIQ1yd+WTgm7Q+j7EchnKWFV7fk6XQ691icOCGStz7LohI00t1H8v66l8btvevhdZNEFzuo6Mrtl1m1ci19jk6YbVtZxql2mS93ACssg0Hz+vbtvKiLNvHNM6x6nwNl3c1UYrkgbFc7RaWObFXHIWJm2P0Ko3HtfieV2ZYq1VlXz1Sl1MkiTFhdrapgdGch0obXm39XXfZbA5IZK3Pct8EGdrfyvwvvqWLeh97hbF0FyuuzS3C7nKbtv5h3RRjiVAzuyzXOAMvV3qorOLpwOXo2nRh4f6LkeivReFXYVCKjnJ2rrLuFZxZCyKliMu5xTauTlfQ8Jy856+6N7q5i3NJvXMPVMG1zIRSoWakbAXbD1+qUdO0WK5MZI3Pc18CGwmm+O9tyhNpO1hu2baxx6nK1SEzsct76trXZmPYiYB0lpTYawFtR5ZRVrNr6pqJuz3z1vgbBdlwuoMQu5V9x9lzBjsDSbjhzb1Zr1ycc0+M5/oyRLVNLUeFJW3O/UzVkcybhMDqM3K3nB1etJ0bLYjgxmrc7yaIAHThpxe3RsvVqHV0d3z8ON5fTqvM69czbq3fVZap0C7E7K7CDhArLYFuVKO/3Z+X2XOu/wCUuvQ5R1Ki5Fcsd1GXHwvuOZoSQpOZ9ZqnVJxnd4Pm12R0AGwNnre20zqyWMI80pdJZL59RRZLUa+ozXabVcmMlbm2PRXYcdRZ9OsPWirunzHn+jypFUSLzmIsp6TiquyUlUuDWMMOHbJpjwCzWroY+m+h8hbdvMU7PFdcYq2KjuSyldbOsMR4QxYbWfUap9icS6HgOZaudJraOMzvpk5XZAJhzp01Gnc2my59y0skK77o19msVwYyVuY476uVW8ZwW/B2KZze3Sub2jVWlraVXOYKaUy1YHXYexFgDMTYIWHzj2qfTPqfBSejOYRbvIVs+Fr2t1h9kpjuCzUtlkIBuO2y7sz3qk8/7fn3M9nFdq2mtWLJI2TQE002wySXpusdGoiO6S7pT6bTZHLRih5ZmtqTI5jM2r6S18PzO3z/AJPXDz9z/O+wVQOakUHXC4KJEEQ1Y17q4ZT1njpPRlWzFV9GyVQyi2TSTcZLMYRBsax2NjlIwMjNrXTaoTy/2/kFSvwOBNFXTq9sskq9E/NT8WpB0YNHLWb9h7HTxutDhwYwU8qyWVF6XRsastnZy8L0tdwbGQvBl0uqgaqLpt3W6lOmVssCCS0l9p4wPS5hJC2HVV2mtc12TIkipcmbsiYzuCOl4rSSTYmZ9Tmk7M8Seh+KAsUiLkWQtodtW+dLA7PxalbVS0cU9T9G53oetZ+7ZWdy8YIeU45UnzSB1kD8/PW6hxd1S4+9xTcCq7VRNWTCxrTcEFNcK4d2hzsoD77wQrVdshWYqu3r0SayVVpGslcqsUMcsjZrBWlQigdZtJKbFQeC/RfFlWKgIEl3KJq7NLzPYrldpahjsEivlYvnO9D2nL6yyNdHrZB0W1HJbGo3OmW5Zen2G0S23n8D8t6Wtcve2y6nSE6O7IdwEBctWawY7E6vOqnrvLLaOjH9kfwEjz0ScAl6ygMG2CBBLBEsrLdrFCAz60VXqE8E+r+HFdNEAgfWZrDM1oNdgdjtUOKWNJ0bbnzfR2TnehYVaq9WKUK6TLodRWLK4u8924no/Sab7p1+HyvjduKxW13kbt5dbytn9qFsmCEgU5CXYd3j1HtcfbOaO4ZpqyuRtrlgtglcjXNxmBditxbAzW4LNtCYrH59jKvViDxB7X4QgkiKztqfstnpzTjUWO/I8VprP0uqcv19lwd6r1Jz84qUyc9uz8j1mo2WIrtEC2dvS3D7PsLJ3ulbuXzzmdRtRY0yXb5+okdCOQFbhRiY7Ri27fP5R1Mdy08rHXQ1Tl1T0GRUScD1IpmRC1FowWy3M1tWkftUsuNLVgfPz2PxJUCIGNyy7USCV23TzLtXR1Lk+v6bxfZ1Naeerk5xdTxvSKJdYxkg7TDmKBOjkjdX593sjB6nuOayr49Y6rQUu6rtLRYCuxFdhHXJBRmTl30sXjLrNK6cvYNPLk4JlhIhpgLIhZBJhYQZuHbB24eNNmVmVFUmHKjOInzh9t8ad1qxuDGM+srlkqtWvnekuR3ejcD1vG3w+cNqcnda41jFpHM4iByakKY8rsdq0xVZ6H5fd9p8bvNMto67Rybqte5729bIVy2LpwCOzuhdWf58ejytLZdRb6Tz55m6rAZdapUIetksWlbszbsqMwJg6mfxXWe13QZN6fnr7n44NyKxWdqrYPaB6XwdP0by+v5cu53krdKY8qtgd1vhDlLVQ6K7hUwcB3iORHmqb/fPmvXdawbcpuChb1XHzXlsGodQ6sAWZvoTgfSHmLtc/Tss2Tgv7NSO21ZXDVu0UlQwEBZsZqIqBsCkFyJKZ3kajINV86Pe/IMETYjZghksVFnV+Z0kR+QMfNO+p1UzFlKlrh0f06VQLM1BsxTKdbHNdrhLLTm1+8fMes6nj1ZVcKuwma5dk0020QxVcnMt88Sd7G2sRRbQtlXs2LJyt/RNOXqtONNNalA2DUAxAYY4wFdkgK5quxefQ7i/Oz6J8fRA5ZWpQUl/w6UZ+hxS4U9xWLajo7Yg6M6ZJOjSozIFGKkTYiw5q7ZWu0dVtrp2+yfOen6rzeg9qufUWkDOLFTerLQvG+jX5N7WKNsQhsVHxbJBmUX2jrjdERfSWPnTFeVqK0QnBTJGyZW78rK0ubPeGN89vonyAbKdUQ0xlf5dzjJt4ZpWGEjrKgodsXNTuHqlq9O4FALJVJphszSPMV3MY7uq+Zp1+h+L6DpvM7M3n1WEx60oHQo889jDzvTlKxLYTJaUWaWx6xWYMMQFYBCPQ2SjsuXmspWQQaNEKxA0qos1Vrqq4Kt83Po3yEQLk16cHczvN6fNa9PNdKMgrIzRVaRwjObKZGu5xIuEsOgFGYYMPoMdb8W1xVodU32OvX0nP0bSmyn308/10oaEZ1wuZYSMZbNKxySuBo2CEiqi3fLZ0OuvtFHPk0xtVMJXdtWlka3K76u2Kqs+b/0X5XkU0VLjqKW8vzbeNNdEOgxGQJWQyAgLhqpKuwxjgQobGihEiILiDGqtRLXKaSreYXnl5zadnWzGLkJIxNC4FhksSrHBM6gWYsLAtVlEa1UiDsT1ty8ssefCJYqm6aYTtWl2t8NW3z8+ifK9rFqmieyUavO1e3kF4wEMKEKXrcquyXjUSFVrsh0rrB3Jp1EJpbAq6haZbhi04vcDSRrTy0rssucnZZyWJIaORYpXcKxgEwCVSoVFHKSwUzUXoWW7pCc+wVUFpvkYz2i8dOls58LfQflpAHUVDP0vBu89m7ld6kDDk2pbMpYFxXzUyVbSILpX3JtoIqJWwsJbFLc4S7Hs1Ljy4suKz4XMWIWMHJGLCeHAFKXSOWLpQlUIpwVrELBLVlsjzInq7l5Eh3kE1Rqyi4knzz+g/NliHau8JbA5dvGTZTLoSLqRAIQVQEat+anwEtW7xLNkCJHFSzLWxK24LHEuKLW9pPLiG1RsTHNCYuZHUxKAolSzYjlYdJkTAuVnBWYM4impdKsdp635SSFckQlso1zlF5Gny6+hfNxFduvWc1/J6d3JLQiM0AwgQdIiSqyr1qnpqmEaTptRAFxkKQ5lsRLVLYR7dpcu1xM546jZoscORXUCRoaRQOwqQHCxcXdYKV1XNAOgHClFVhYDQ+j8a3LKj6Z7pl6NgzXndflz9C+fbkSw6dg28FN9HtVJjYFYZCkcK2Tbo7lTo1yiiZpu0yjBQxKmgquMMs2ba1RsKLh2hDMqWYLHUbZO1jgEkmiNxcrhVCoqFDpVRF0peKCo+wSCHjdgor6vnyTaizY99mz6EPPmn7vwhItjrtfZtvBmeqWxKM3aLBwFtA5AyxHLI6amQWuaquMr6kGLCraQPs2aL7Z8Z9y3TEFsUr4XdhhwkEOIsTIuwMAMg2KxpCRVxdKzwTEY8iQXiv0RqPWFfFNm0H5/VVn0pD/PD3fiNxbnm2VGjTxy4xzRIIoUgrYAEPJp1dvSeVvDTMVWPlsXLEhipc4FimduzKLbjpZ9Fk2Ro5VHcqyJFguVm1XcXAEhTqFqqQFLDRBKXoOlZ0CNhIV2zLp9AJ5hdehjzOxH5doUPzg9x5BzDesO+hhuWXgIYKtqETBakJBzNMrlkcvQ4NUpW8pVYeWJV3iXkaxs6hsixYsuqWAjaZg2ATFyGECcQqQgTYXSqmIRYqDaBYh0IoHyNuQwZLCQrsOx9tHy95kVy+0z5/VGG+XXufHdJrtbY9tJac8tgwW4bQIoVCBMcFdsD2I5ap1EfrJit3KWkjvU0RzqmyDc4W1LMhwPs2JcCcKJ1CSslrXURcCkVKoSKoDAVrCITGOK7DQqiqJcK5w3p9vMdbmWw8r0z3n9LTz5Me38p2zDrpNV1OeUS2JBGToFAgoUSOTMZDsjkhyUewPFMzVc6jqlrF1Q5Gx1GQ5UrKj4GwlLDThEmlZYVIVaopUUFKgUswRUmwX6OVWIIog0YgJ1fur8DtE5tx5Ho57L0BEfM313BtGHZSIaq8qd0EDpWS4QjDEHI5YLZXDA5jkqYA8MqrTdVuM8Y6DdkQrcjJyFavhbDEwqZW7AcC0GguoilXaodQVClYQHQL9LNwHkXI6S1ch1b0Vo4nebuPKZugWjRFVW+T+qadnv5GzQ5WBcpBQGSQlSkkBV3CWQ1iuIXJQkZcLkyfrY6mOtASdsVgjcpJUrbDLMTIqARULroohAlRirqKZAaAIjpGKjuK3UykMMSVGIGVD37TxO6dDiDdjF69R1P//EACMQAAEEAgMBAAMBAQAAAAAAAAEAAgMEEBEFEiATBhQwFUD/2gAIAQEAAQIC/wCd65FaI0uoHUDqBgrWS3r1Deob1DQ3VMD/AKnq+moo5GG+N7yP4BDFRD/qer5a5zid73trtg9t7Du2we3bsDvfYOae1Mj/AKnrkfOv4AZGAh4CGKSH/U5XowyvV+L2ddaaNdWx/quZrWuuuugNAaAA1UQ/6Se1hsFIizYFZtJ8Pz+HT5V2Pa5ssZahjaB3tAgqohn6fT6fT6/X6/QPB/m5SuC258rgNxqcWGxhlx19hnk1LB11/AIYpIZPKf7B5j/V/wBX/U/1Ir9XkYnj+ZVyWOd92bkIIWRfNxktfH62Y+Ms1qBsw8i6V2SOvXr1DeoaG9aYGZI/n069Pn8omqlO1/btvfqVcgY5LE37VK0yzyXN/twRtldx0/D0qxsOD+Tg5SKzv9TpoRHyMVUMyhztpq0E3DHs5EcqOWg5Brh6kVuKYWnSv4x9vnprtW1Q4ytBFda2xy0D79/9V9H93jeaqzPiJdLve9hwO6ZbmdOIW24CZnXUtrMrvHkrT2XKssNvj4nyTLjGXOaN6vYtctFdrF9CThb3F/ZcPbTvAwAMUk3Nl5y077NdvYzVEQah6mfNMKtrg+ZqNZSrSXLNmsLNjXEQ1Hnm+S5eK9Mxp/HpAZY9LWsAKohmy0oYagA1o66zSdEm+pHTWIr8EfIWOQhhoA37SY+eXgeO5vlG3foX0X25geOtQcoHb3232Dmu7Uy3NrGk1aAb6qiBN9TK2uF44z2H2nWnzzuEUEcDIHJscsZaqzrL4nROoTx8rHL169egb11VjGbCcgQmoIFp3vt27UzCm+rKvWIIbcboGQclDYhgpQU/020pePjpzU54HsYZHNTFFLBZoSLXXqG9IYGtGbCcUExBANbrQb061FCm+p28dVKcywiroFb9eGMMLNMjkhtwzNTgxrYghJx1uM9w8O7RGIAZsuctgtIILDtDBVUQpvoqlXcpJbEhVhkburEHLoA8XBOjH0LQWOcuJqBqCGIFGgUSXWA47CYtBNyDvdJ8Sb/B8kshWnCxTij1oA4cbz7DimveUxRt4WqMaGIEw9voXySWU/DFGhhnnVRsKb6cr1m1+Q0ec7LfYoMxtWDbkmTT1OIWtNRnmDDz37bslwQTDsFru3ftvdNRJvorlXycs1tKWR1ixJysfPM5eHkQ7akHJMetYhC4WuUHdu/0ElZ25Fve7IeANMAWmN661pUlCm++Uo/49qLjKhNyWe9RQ4mTi4Ux+OXiIKcdRjf43HoDWkFCQ6UoFWi5DDEECz1UEKGd9thSw3+Po8XakVuD9FvEfsVOXC+WOTEmNdY104WPQb1DTGIwxrnOObScQ7bTsJh7b327UnRIYJlsftx2dvuS2HySyBSCSCJ4ToI42vxdZZjbFDVn4MM4+pWg8hDJAbq2nILcabhi0gOvSmyFNw5WsURatSzcWZnmORCf5/FsIZrS1MJ6dPi69WdvMQ/j7N7B2DsEHewgFac5AJjmkOYd7CGKaiTcOVtBQOe+eavOZRZFmSWBwHVdS0IIhkVxVZORXOGhX9jIQxZY+NbYAOrBpBb7UnwpuHK2gmK5JA2CGdFjmMaEx21p3hrZhFNOa8LWdeob169Q0N6FmhidOTsRoIBnkqiIE3DlbQW+RiMnE8zLOZmy9HR15MnAQTlDQjitughGR5GNoYmc8lvWMghzXBwf27b498KbhyuYKkEVejTkZLQdx0sE/MRzxH0HK/yPG1ECgh5Hq0hiQNAQja3Wmxtq/qVYYE3DldQJMZgZbUlKWea1bmbw0cEQxrQTjd5yKapRA0G66gZ0BrWbLmuTywxoJmWBgcoVEm4cr6BJ387cS+Qptg00EjzYno0YIMBNDWCP59BH8y0YPi2UHEsQTS12I3smdPXkgLcOXIJuHLi3WopImNyMbW9l12GOIHfbtG9haWl6YtvId23vEs3bsDGQ4OjPgCm2BDDlyCaU5cTLcn7EAbHjsXdgHYGdscHtl79/p3c7wMOm7dxJG/v9GP8Ap9vr9BJQkhLcPXIpq18ONF+qH9lsO7mT6bA0FsluNdWMEbYREYxH1Lda0hgFbUb2poY3roDSoKsjI6+/kJnfU8ndm402FLTcPoHbDenXJP07tf37NdEmJqCkIJLj27du/fuDsntAmBijyFDXZxQiksyX5/yB35Meek53/Tls8M+YuUjXRCMMDdAZnPUYEkblG5rw8vMhl+pk7dtuPYP2Xdi6JzHiSM7rVIOLMstmfkZORvWbM/3+0cvf7/jMtl+C0M6+rFSfkMtQTE1DBWk5bQWi3qHbc7cTmmMxKjxZlt3J+QHM3+SdyZv/AFLg4FUJvwezbfgpn8ecl4DlKVrs17XMe13YOc/uXl/bux4d2TcFbY4Pjk4jjbFm5yv5JzV3l7VmWx23vYTcVpvw3kZHZY/fp77U0cnE8hXuuYHxPD/r9fq6US9+3dr2v7BwXZFNc134/Qszc5y93lLc4c9zSPAQWwo7HA8ytYGdLRX5JyuGn6cdzzGtGda1liAAaO2+2waMN27Y5vm7PfbTth8hbaVx/IcVzIctddZ1zXJSy4CGKt3j/wAg6FNRJwUVtiYnO+m97QXHSxnlHvlKDhhnsIIgGjd4vm22mziXtvb7HJ/k1m2hlud8fzVS+u29k4jTU8ArYKC5cum5J9uRyaW4Z/DcMjkHQWKP5ELjL7Lpv3educ3geGo43tr+N5/S2TvcRjDgt5iZ+cozylNIQwxDA9BFA9ga92vz3+9Y51z87W9txve1x8jOUrWerkUFEoU8yHAxwFf8te15IJRyzI8nAwCgd7Du29g7C3sHfiquWVSxXvOKao0wuJchgqq/mHNy9BBbZgID+QW973vAO97C2trcavz0BzE9LlAgQRKZvomoJrOYsTPHgIYYggh/BqIQ9DG972DveNtO4ZS6pNhqbGYf19778HHyVj6nw5DDSCz0MjIQ9jG0FsFb21BbBjNKRxrpqCOd0lffIrB8Nw1BRlHwMDyMj+AOwVtDG0xcHM4wuYQnY01t91l3nYw1BMPgez4GB/AHe9g7attXBv6xNYACtKnHzSc/y7AQQTS3wMa8nO1tbW95BQQJQRLTwsnxawH7Gx2BXJv2cHJwEEEEw+AD/ALaGN5BwMBb8VZE1rhKQu9dsk116OR4CCGGeACitg7W0fAW95C3sFBBDAw1ULLHadH03w0RNonwfQwxMQzvG9/x3vaBw07b4attPCTRyMJa5u0Xzne/YQQQTSzB9D1ve973sE4aQQtrbcBcIaxhLy+SjVuTd5HfxCGAgY3J63ne/wCO+2wd7bjewdrYP4smtDi+R/EV7vGzKV3oZCGBhpa538N+t7WwV2Dgd72077dvxac2v2/2ZLH/xABCEAABAgMGAwUHAQcDAgcAAAABAAIDESEEEBIgIjETQVEwMkJhcQUUI0BSgZGhJDNDUGJywRWC0bHwBlNjZJKi4f/aAAgBAQADPwL5ioU+yp8jT5yuSvZ1ur2dPnJfOU+cqPnKH5wS1b3Cr4goBQLAzFhAJ2atefE5PI0w6dVLf+VmI4Ks3UCZDbXZHwgFPjGclCa3WHOKhSmAJTTYg0NI6qXMIp3RcOpGpRo4mHI45ODnO/Caw4QK+qlz7WnzMivwtPqhOgWELzCxkT2UQOo6Y5DonSMmofxFiMKRoKkDmoJBcBhPOagYXF8ocjIEnvKGYM2bkUWFrXEgrDIDmqTbMk7KpKr2u+SOOn4Ubr+itHl+FafqH4Vp+ofhWn6v0Vp+v9FaSO/+ifOUWSxDtSzEhEhNcNpBBsaQ3kv2hsHiSc7coxTMRJCdfNN8IXouGJxnqEe64OKjt+K0M/Kie7OazBFDu9Ve6ua3GDrpPaGrRaoXxmh4PcDRujZ2kzwz8HIKGIrmTdo3U44ZEEqbpssU2przJS2M+03yUVc0gpIFg7TZUXCBAdKRFFK2vJPhotcgAXE6nJrIQMQn0RLZ+HyTLFCqdXhCtPtOKeLEdLpsArJZwNYLhuVCtenGWp8CIeHH0KFFZ8dwfXcKFY3OfCBJ2E+Xov8AzJEpjYRfanMZDPLaahPe4iGSRtiP/clFdHw2d0sQ7hR0iMC2YkRNNLA0QhMp4ruhDbq3U9kQJndV7Oir2DoZ0KI3kE7mxDmCmRTJTz0XGgUpJOdOXeCM2ulqFHJvExN3US1WsNL5NFXHoFigltmGBopNOixzEiHFLaajxDghaokSiiV4+J3/ACoNmbxIjw1reSg2x+GFyHWigs73JDHhs40poxviATmosa0uhglx5nk0IxJuMWHwyZHC5e5wp2V3xTu47hRoBc50+KTzOy4rGsteCZ2WMUCxbET5+SZZhticnRO8Z9hvkotWameY7D/480TN0MrizkWzURj8TWmSdZrLGPiiHCv2drRyE0XmS92cDDY4xAOSjYCzDwwzvzUW0ObjecA5Iw2UdqP6LgMDDaeIfpaP8rivm1hryCYBhj6SO8rJaocmQXYeZ2mrHAnhi8JzqSmnwQSyPiA2msOi0N+6MKrTs6a94hajqHJHDRuH/KdKUTsd8tT2AyUVc1b2t/ecuS/1B4EMEN5u6JhhYRL1KNnfwWV5r4L8ZlhCe6O0NGp3VQ//AA5YOGC11tifonRnTiGfNBrMbuWwTiA2sjujj35UC9xhG12wSYO436ijabU20sfo8fRWYMq4OrQdU2I8hsFrWjaspqLahIu26Gqc+LLkeaa9paThDdvNBrtbu8mB2/3WKs8SHl2lFX5TA0qjnjYc175GLYcPXy5rgQw3c81w2DBVx5IMY97u+e8UHw3GJ3d/U9ELD8TvWh9G/wBKdaoxJM1ieAhMNOwT4xpRnIKztnaLe4Fre6E72jaZMJ4TNgnwLO6E09/9EGT3+xQ5bp/vDcCMF8Rv1mvkEH93cJkBzS8TkmRtmM9JLg16ioUxOXYTyUKqclfkPhmaD/hgTHMJkGI6OGy6TU/EKqG3zcjbIkmmbGowhIeFPxzmQUGNrV5/RGpR/wCViKMMFh7qLjMIzrzWFAoQi36sc1xg9xWFy1bgJ0GO1wdiHOaa+K/EJs5A8lxW6TNdcxnJYG5DJVyV7CY7ClFEj2kQYU8RcuBZ2M6CqwiYaDNRI+8gPJCE0NCxhoHNDiO8UlidiOypXmukkeKUH7IYbpXyh+qkpoNoKeapqM/MIRIEwdY8916fnNWebUe0l2E2O9EIntLGRzmqKlUNm3VhnoVxHEnmgGyb0WkKV+kKi3UivJc0CjKlVOjgsCZDIM/9qkwZZuzCSqb6qqCEs1OwouHa455Da4NQdtdjhlv4WAhr92qaLLp7ZJtKqulxaUQnEbr6kbSQB+eikJdMutUy0VflQyfmhyKLrq3CPXYqJDMnyl1zUW6m5UXJaaLVO7itquHCx9ds2tSyHkqLUc1O2oVGYXYP+yollMnwSDzmEy1UfpKrcEE0oNyyatRVVvNa1I+qJaZcl+VsG8lwrPDb0bm13SGSmemaY7CYTrMyJEOIMZzC95dgk4/3MCYx88EvRceCCw4pI8lGa4ioCjQnbzRPeElVQnS1SQeKL73YmLhuquaq1UJU5+Sk0m7jWpmLbc59d1LwqITKllpmI7EWkOMerfCOiZZouOCDPzRe7U4o2OzkxO9EuDWzQx/EYxWC07tk5QH1hkSQb+7FVEgGoMlivmz0UytU+ip5qTZLSAsIJU+JEPSWWl2F92lG+iqq31upmp2E0IrJOT2vkXaU0xMeHHh5lavRTRUO0RTiGFyiQ4wfixAfYqNZ39xx9EH0igj1CbFCw7X/AAipTu5rT5lavRYpBYbCyXirnqiESEUUVQquSt1OzDDVNQe6Q3WEJsPcr314htCh2KBILiRCQLpoF2IUKI3qmu8IUNw7oRhminfihFScQsdEYsRrAFEhQ8bay5Ln1XvEf+kbr3XS3uH9O1oVqOSt1M0stbviFx8IXJqmarDCjRumkJ0VxxIjZOEpKdHIOFMksk2rixDhQhRSXSkaD1UNkQuLAHrCZhNY+E9gkItSu87y7KmShWrJW6maYy1uwMi+lwNE+E0tadLtwjJRB3oYl/cmO3oUC/RVSobpX0vmg2ZAqi4CVJBcaEDF73VYGtlzQabPC5tZVcCA3zHbUNxHyFbu8PqElw2OPRF4xHxKgmpUuDnVagNgsLlNual4M5HYp2LAxDE3H3YImU/2jb3Rou06KQ7ai3yarqZqZa3YfssTX9CosGzB0ITw8k+3RnQXMcHtE1Iyc1eSa7eiBEwipHA77dhocGd6VFhZ8Z8yocGkJteq96j+6wu6DOMf8JsESaJdvS6aldXsKZai/HCryosbIjfND2P7RiR44OCKzCJcqqFapd1wKhBjiBKQRbAxF+qSj2aHjxCqZZImC16TLdMtLMUIg8wViYDnr63cOcGxaop3I8KNmhHH33975Cim43abq3Uvmp80Fgy1F9S36lhmfNCJQnbkgNTMTDPwlWzDh47iPRWyNDDC9rZHcNVqtGAAhgbv5oWiJxLVN8+RTYIDYbZLDDF9TkjWe3PZZwwsZTUOatvtZ0nPww+YaJBNs0MDc8z8jpWo3abq3U7aRB6L4fEHddVY6rzknuPeCn3nJjNhdN2cQIESI7ZjZp9sigkEYzMuKZAbhhiQF9csrgpZ6KpuopqV1LwgNym9VM9hRcSyuY7wlcIyN0t8krpXSFbzaYYheFx1JsEShiWSqrdpvp2M1XNMZqZdsgbFe0+ILG8+Snvlllnt2k1JUU8+JSuldW6mXZUrnonHvaW9SvaXtS2PdZIUGzWJjtEaKCXP+ydZazm080J5ReV1vnlrfS6Vw7OareZZZbI3MhjW5rfUqCNnYv7RNT7kI/7jJcY/ELG+igs8U1Bf7SkdoELEB5ky/wAKdjMyfiSb+UBZg1vJYmEGqBPwyWqLD3Tl1RRN8lS6QPpmqtS3Wm+nZ731VFTJEjn4TCfNUnGf9gocBsmEpjd8R/3KHDbMBgTIXNY+7TpVTG8uaf8AlyhRPaMSLEEXjPPN+mU6IOszYk2yERoG/VYg9UKqp73yzyhyBqUUQjklkndS+eelxQuMro1qPwm0+o7KDArGPEd+iDRQUW8tuqk6pCbhJdLTsi8Ecpb9USZxNv8Aqq0lNGUiSQq7ohzSOS4nsdlZSe134XEhRCpNur5djVQrbZzDjksO7Io3hnqhYAxtp11wPI3BQe1r4ZDmO2cMlck1IZK5aLqplSvrcJLiyiWmjOnVNhsDWSaAmwW6jUhNmZPFG1nyTHHA9+/VOEQjkDyT6idCi7Djc4gcljd5lVyF0DBE7tfVY4EVp3AU6dpRDjmEN2vM17rxGRTowE1Xv1mEVsgfG3oc1L6X1zyyVQU2iPaRJvhaeaDE2G0nF9keNYnQycJhTpzT41GnvCqk9obTAAuNU756Iw5r3S3YIh0xdliM8mE9gITC5+zRMr3i0xYp/iOJToTw5m48k6xx5T0nqoFuFJQ3/onQjJ4zzznqjLNVWUPgvt75xognDgn/AKoBk21WCG1zdQaZORiTm4oxrNZcXha4f/ZbLE7snQXtfCMnNTfaFnAedY7SUI2eD4u9fVOa7E0kFBgDLT3fy3/8TI4x2ZwIPKalvfPsZZ/e7XDhfUa+nNYXWq0MkeAzBDE+aj2CJCgvjCN8EEkeL1802PBiw4NKh0lNTgMHQns53RLBFxMNOYTLbDFaoO7FlggGut2wTo0QufuclLo1kdOA8t8uRUK06LXKE88+R+66bXUvlvdVVvkqZhZYNstTv4UKTfUoj2MwnvxX4ig/202bpNJFRyT4VoiMjVrJ3/Kk5aCPPs5FaQ7kbn2OJih/cdU20w9J23HRByBuneyH3iAodmBbB1vUS2RTEjumT2Mawyb+8hDwnl6KB7Qb8B+rm07hFm+SirkmFTN7t7Bh/wDuYs/sE0ezLPDJnhhhY4gc2uHmuI9rx4m1U7qnswO/VpUnGW3K59niY4LsLgmRRhtPw39eRUqzojc1oQhDvBqi2ikObR1U9+zLHBzCWkbEIuAh2+v/AKn/ACgW4mVF9Mk7pBUyGJEaxu73SCbC90gw+7CZIIGxwjXuAUWITnNThS+m6TlqPaTrd1ui2f8AdOMuiH8dn3aoAGnG77KLFpCAhj8p0Q4nkk9s0uwODZdSv9PeAyb4U+5PZQrfCx2Q+reipkqpXTGTosVpfHO1mbMf3HZGKYL6YZuX7PK+TlsVr+3ay+VabRDEU4WF1Smw7UWQpyaOai2eO19ndhfNe8HBGAZH6fV6XV7L3L2U0+KPrPpyXFs095Rf0lkotPoqn07WfyvxGf3BCPbIr27F1EX22CBvjCay1Sgk42bv80y1wBxTKNPCf6shun1ycaK2G3xuAQYeG2rIdAFxINoZPw4vwcsv5KYLw9hk4bFFxmd1w4zT9Lgb50uKN+lYrZxOUFhd9+SrKcp8+q/am9DT8rC4g7j+T0yVXFscJ39NbplVze7+yYsQ/wAZ4H2CxMZWQWrcKcQuHirkmFp7enyszfOyFp8LrqoIJsud+JwHVCHY4UNk5NCxQj63TGWn8jkL6LXEb1ajNVupkrEic4bdP9x2ToWAOpppTksTXNnTfPTLTt6fJaVht8L+rSqXSOycPCj9N/CgQGmfxHcU/wCEXtJruq/yit0zfRcKPDf9LgUC2fW6t1LjaI8OE3eI6Sa+1xXDuDQz0C0uHzlO1rkrfxrHBd1YFRTOSTbRaT/DbgZ/cVhJA26rTdTtqqQ+Zpm/YW/0mSxbKZQWm73SwQIEqy4j/ui3agVHZ6/yOuYmzPlyenc1W4YF7zbIUOUw51fRcS0RHg0Bl9ljYW7EKmB1HDPX56l9VLOHMtAPUIBC7TuFZ2QIsa1xeE92iFPZRYBnBIjQz426kWO9Fj1c8+rsZj5iZn2AabR6BC7EEZFf/8QAKRAAAgIBBAEEAgMBAQEAAAAAAAERITEQQVFhcSCBkaGxwdHh8EDxMP/aAAgBAQABPyH/AJmYE6iSDk6Q3Iaep3QhrcDdDiGEqEsQgSIMgnYoToyRIiSGwMsmRN5/6rMGJShKFsw0LBuF8mRAkkmTCPpoTn1JCFwLTA3nZk8/9VmBOR2HKQodtKvosIiWrGEsGehlpv0rlopsWmtDl0TN5/6rMHoYH2RJuSRF1QlAutMS0PsyRoYLFxuSLKIsIWNF0LAnyf8AXWZIR22IkWCE+dJ3Iy1nHJEyy9GYs4LmNYYoFE9mOxFnyG4oEhGSgrFdECAQRpRAq9C0/PoySSSSSSST/wDWRCUsgk2ZyclhK2EY0h9jkzjpypgUXz6gwoecIp4XYxsqjwgTyuXyNGU76G3DmJX32IRo4ThDS4qQX2ucBVYvwQZE6J0EEE1AiBRQ1vPow5IckSPJDkhyQ5EvJNor/wCbRPYTu6KWNV+Q4vzCGcjLjBJcKXgZOwQC0T5e/YxvcX7i7wzk3grdFEiB9LI7IcGJdi0JTolaXD3ZQMOEL+RwVNJLYa0vd89IaVWx0IGnBYk8CQhStxDavyejk2XMpYw0kuKTyhcOIlFCdgvNZcxBDvkf/wCb00xImZcDy7RE4qTjy4QuJIcsUVzkNxpSNiisJ0SyCXCpIzbmOd0ieCGpM1fLexfmdzqb8lwQS5zbfCEVVEwfvdl9d7Q3DFbijavFD8XHIl7DVy1Q4aEdkKJ0U2+hOjDQfoAgXl6KU1DSRBIjwJGRnBw1YgE9iZC00V62eyBig1TazwVoYTbIaiFKvtkbbxSdxmEO7nxoelroG5qmuVskjrsBWURzQp6MTOzJdk78uyF1p4GJN7ppwhLL3eOGWh0UZeQikbklNL9Bwc2so8CvZCyfJ2jCbRRSE6cjct46CsgxXS5YXC7ORp+NEyexPXi/PoxPbLHkRkcy5FEInEk+aOmbsi2b2Zs+Ro2n2tM3qW27VpC3SowyEI4Ia5ROsaQo5wbcLkbSubYyW1uD/Q2S+5I4uBLLV7Fqz4ST25OTbKNHMvyR6c+xCBucXt0hxVPblFCVRcCzw/wtxIQV3N+NxC79tfAXd0sSdC+cBu+mU77U2/oQ0K7Dcia9CRhIlpTNxQR7DmSe4w1zF/yM938CLtictGJ/mSJ7I9hI9H1jJlDETkcXoeMZY/7l3OwVDOZshTT1Ew/grgHmR0W0tPrcWtyPeKCtGybtJa5fn8Euv804Qn9gvhLwIdWOdhc5ObCrZiJbKEO/ZM/JbeWW4akLDOWKzbhVvRmqP4djnW2LRAtmNo4M1BvZWGRquyL57EKthPSPyehImUukW4tNWEEQREwZFLgcC2Ihh6UfAbjJPSnO24shuURXCJcCnb3mNqJzGERoSza5vA7hLTTC2GNBcqy8PyeTyOF6Aku47jdJx5WOhzsjS/ISH4S7fl9D0sQQ7fwh5DKKfyQy30qzuTDNz3qN2KNIXat+Cc3SUfBJEsvNnAmcaZkcET9xJGAoexCaElGhCEp+THVaYzrsihJZMiwoorJWJkJMlklpfQvTMRKeJZdyXC8lMdE7dJFzkKtyxvQIMeTT/SJgd5Lckxd2FFv6DhPnsafaDszHZFm2kcETzzLTfZ8Bq/gZxSX4G1fEFcHLllmNOdltuRun+kCfJXLtCD0mNvgeSqnGwxWWN7wPJEIYCXUWXohPz6DRANfOILvTgTZNQtbEGDwMjBvjaF6EOgRnlEziRqSKhWlSJi0vryTjleQmWZlxhvgbVu2eTwUrGJvsVkSWq9hlVchrKaeY4QqheDiSFLZJQYZ2XDLowybFLJTEITmUzHUjZjYyN2LuKdVmjnSVE2LtuxNuCc8iI1ErF2VkdEpbH2ZfoyPPBl0XrI16lWSJ6UWFRiQ9C9LuKtmR1UX/AFQjItabljGJXTDFr7aF/IoFJJbCUWJRJek4dxbkpL9i77lCdVn6LpScXB+cizKK8D5cLA93KwRtzRD7kmt8S7FD5EJJzOIqHtCShhhYeyFmya3lrIZi4q5WRCaqocCotpFljkZ5INlAqBLyR8EuBBuK3vA06F6fc02i3h4Jy5EuuaGRfgNh1EWOkTrwKKY2GeSVGz9xTbfKKfycJ5EN4M6ENeTe4l5GTcPsUoh0Ilpx0Lf32JYFLhy/BFW65L4pHYPgTJlIUeikYYzo30J2/AtBKw+tckYJkRQR4EwThbEF6Vt4OrFe6xpoUZocRWNHP25bEcYdD8bChrIme1xwKYibPH/pQjOSDAlseBDYVYdEbXzA6cN/JneVyxW3KU8oUQ29pciP8BDQzQ5I4fQToQj05E9iyHmSwmFa7FrFCT2FKzoL4k9zaM9C9Tv8xpljvdGV7jCZHGPDEaZskLEWmgmNe5GzqyESG1iOzGttkT7Dx4HKilk882Jh9jJtKVKCRwRoQSE0hRRDkXGSdce87DTnzpPcRtdiOYFYgSIIIgacG4tZeloJIJKhxythyylB8PA7zPLItGogbpleaIOBkRTMA6KYnA5Y9hYglYRAhuSwlabnRSmZhDSY4Clo2sanctluTI5E7LQhNFGwlYjOLSU/JPnTdRc55sSnwO1k2xNI2R6HM7EeCMDUdCuhelZET1xaJ/ItjyNnCRGefb7C9ohsTVbEkSBnRt0Prm6GNZmOS9I3kveSSSoJ2yeGthCe40t+w3W7ljhM5G7mFO3TcQS3eCCYPoGU16QSkriUdTISQ0Fp9zwBiWs5oTzgzyI1NHVkyTIY2UadC9SSYiOBxMSkqYb4H+tsTtXAtTwNTZ8FG0sxFwQ1DFuIF4EXKVyRTuPwqPqidJZ7JvaxVyE6nhMa+xIRgoYPyyWBWfI5MPbj0F0JHgwwchpBOS0J1opkxvIm5ETuTP5IMbDq7sdRPAR4aweCCfVob9NmhzhjM2mwyVGyhK6WGgiFZHbSwRV7ODwutUCepLdrgYp+8DHqw0xbz2FloiThmLDoxKESch/nR9mEHA6otkuVZSRKGOGw9pSMZHuNVBHGdJ3OiZCcifUW+h25PbTQPDsfkYXpRTEqJ1ex11xEKYXMIWdgaRyL2Dc9OmTeUpfIyDk2SccjtmxBEa5Eq2Y7rCNeCiBPXZANxS/Hk54MULfcYjRDP1vA5vkCEqRKCuapTT3InfJchUJksROjLRuiU6dKSX3h7MNDBJbHUJOJIFiN+Rtl6bjEL8YEbbxzGxum/ajEdnOIJfaQ4HL3G4e4a5gi7IcMb02EsCWyEZ6ZGJJcpfLKUwkvcIZB8YEOwMgVBq4aJE/iQSr5EaPTTfpekqIFk8M+xQ4SZ72oUBLuR9kMhkVOSCRfQ4dE7Wyjm3LGEfof6+eJRQ2MXGDJFFhignVrgbb8CmjgEvYjL3LCgTyxJQpYzyIpx+eRkkmmXTIyqKw3JAlNv7Jil1TTOiIEQRQtUacdJ5DMS0luOf7HTwJp6GwS4EmttCRZGr3NgedWJi0NL5cM48Jxmkg8xadKUQBPuh/Uo6HibIho8ckGBsGkILSbxLE4FJlyOsew/sThvq+BKEtha/1F7xmgvFTQUCq0WTnIW3kv5Jk3hoIMiR4GdSWYkehx6JsmstJWeRe4r0+90Oa9drEIbEJ7FqLsebnZJMFH0f60xZmNJyJNjKI/Im3MOyfhkimMzBULm9j5ttJELqUOBqEyUOmUJVomPZI6abtLxI3HOkbBmM6BnY6Bh2CYkN+DBj0GOiWmOaTk/RLN2LiKu40lv2JrDxWrlHkigeKTCKEhG0oQ44ThiCIZwnJsxKJ4IotxWBi+hUhFU1OE7iw5sxXyMv7jgu6WF1pSYDw9FgyLTOiYsaIm8G8OhQ7EhAi3MVCtibKej3kR2+CDIaFbGv6DEfWSV/bXlEiK2JGVuj2VeScRw86f7litHCmCV+JipM6meALZJwhqnAmpNhXGPQal4IXnv8mxhdT/AIqWL0oXLN2cKJTB9AncidKhok1sJMiMLS0mSELGiZmWeRNRkxC5kFngdRkZQscLdCiRFYIkKRFvViNDXnWHHd0oTOP+ALXOVwQ1Km3aFUQvcyPiLaR8sUyINoRzZ4Mxg3J+DM0gsVP2BTbFkCgSICYQxTVkHQ1ErHBoEsgStFpM8D7BhL/IsexcoFxk2hP2J3f2NK6YhoGMSMdgm1YjWhu8mR9zE3Sn2YlvteBVtU2RIDon4IF9hbzZC5NcFyXuPR2mSLfpbfJUQhL0MshiGXkkFg4xYoLNDdiC0gn3shP7PhMpbkmQoFpFyhnTbFRYkeje/LQkce5ur2FpJ1RCFnaRVJbYwoUZia2Jh8DzEPP2dgxSZpaWZ+RiDEzfRtHPTRpRKE9JoWpuH4FN43Y1S7ZAPtMMQIPW3AsiXBieODfIwAt6sGbCZJfhY76xW9hES66NeVJZGKbpu4zlY5KsrYb+Cqiikg4ZkssJo1wFkPRczjGoqSDLmahTFWgkcCglqRxELFa9DrRGrBglqpP8RscjqDy7gbu50xNBVZ0ZkOAmXuIyVLuUoT2+eLFHlP8AIexpFhW/IshIW5ZP2OC5cvIj2NOmyX7Kd5xAqRUjWGOjc/RWvK5JKlD6TyJyhM3ySCF1ISy8IifIS4EucDIstNWsWgOGDF7ItcpgzGMR2PMXcduKDQ9CSUfsk1mxiWsaHQN2S5MKKMPKkbMWK8l8PIh+W2cwcipjPuVE+0lhFpTI92BUj+B9JpRBcyktzCh9UUZsmlO4tWQ1k0053OqqDNbmTayB9hMuCfIoRZK6KXuM/BWhNhJuJHZsNuCdmMGMVOScRFUHYSiB0L3iYQjIwGjdUMF7RgszOFsWtHKsqOUG/YxYOaEFCY7v0EtKSbIpllM4CnJSeByqtEFEsRpRBTZn8i93FcNPJgb/AKByamyx1HD2kTttWsaXbwfbT9wJWOaR70N8D2NeQo9gVGYqMHz5EeBnYleT2Wp/BhNO0lLftNQxRReXZTRCIQsRZYJYzsdpNibQUHIwUYikujMlFxlSC2pAgvYlKytEImY3/qRkm+1v/qYsCSSo3URnOCSQEZRO+F/A8kYCZ2uRZq5O5Ro4SOGlwP6lUyx8p9yVZwy2tsQTEPgYLFo5iUUbOESkhJPRgJKsdDjYT7QogbSYx5FbolrLf6x+DZ7htvFfYlKRpH1dCaeR7RYLZYJJEapoW1WlwWco1WQjzvBNjBATobE/gTTN7jqXDKbkTzIrc4TKQ99ZPuX0JInbBA9KeSuDl/LqTM7Umu7M6iTc5Y1JaCeH2eQmVqnpaxqE7LkpMzHJOxsgkMkdjGrgoNjkXtvrhjfY1hJDRoeZwhn6ArY4BLDKP6YnJRh5QPrdNw5dv7JcFw1hnYUELPoOlMmnY9hqUMbOT7itps5FLN4N5KZ+Rs6hjlrBTex0dGAKqwfwo2bnwODoKqMiRi2exGkE3s5HK0uf4SoOblsTD+NJidMaH0vDk2cAhFRihiX2Op7EW6GFKVHgtK0lJVyIarzrjgkRBJbCQc8j02pYal/ftoS0KnIvZ7jJ2TWwmfQ1EbjiIw48j0WSdxpKSbdNjjyScqx0sje6nkdbRh8f4DU5OBksF4aRCilBc3fRPsjXWKjtVf0NpyzNOP5hlmokX0SZzowhhMT+RBab7v2PqNL5T7FErccFyQ6ORDQlOlL40IGJNs0kaxp09j5n5EK0t1CZ/wBD3OcHCaIJDIVcjyJQXLQwlsHzBGSUh7JhklIoKhsYpa99rX4OWRLtw3CHtFTNZERjzi34T8knpnzX9D34JGFohFaMOUSnB4JhDf8AhCq5/chQbkhD7IxQob2X3Fc+6F+6qXA7l9ZElFosj1omKRKDe878mxJ662ftb+w7F8uTBs44RjppluzeZMnBJMZIxlB9nU5GNzln5jIWX/VX2LopI/3BIySRWLQiVQiw+eSx+BiZmSIWqEOw5hcBoZJYn8CYXmN8txY4r/ahyQm2GmY0iYuyVuRhlHzbJh/yROTS3mRPQmTWjjEiHUfDKWIaIKU6f57iQMltXP8A6Mgsk7Di+BXInJNymkTQNK8cwvsTcjsxbj3nAk1w4idRinwJpGbfkvvPpm0Yp9bUxNFDOkVo9xh4cibpi0Fz7ptfBQUf+8DrrkupJ8sZDC2t2yRMWRCRaDDelaaZaGW+LgfFRZvpLdI83sGmXAiSGUsZEUw8iMpEx0qrSw7kd8YeD9haLUL2gnSjhwfARPzpqvuFkG9CwLRkQsEz6JofESthiEVHQQUNegxT0NImSSLHEFxIpFXQe7oJpjOve6Xn+BSN7DsNE9lmSRZOJvVPIiRV0Pcy8PopJ6cvuB6obkZaRZw1wtpTsXWSJhEjEJmAnAiicC5o8BFFBORdaK00H0NyIJ6HlUxNnuZF/wCwiHbZ/IrO3zLHs4KjfBpthr0/rNkNS3FJuE15GRBt2Pm0yKzbyTlcFLFKBVor9geG9HYrVjYew/4EMNZjogQ3Z8a4EOPTAT1ROiRahaZhCRPRZodgxzYe2Ns5bYxO6+wN6tMXyODGONQhLWlNhjhQknWU/D8iRtwyCzuf2kgV5AQ/Oswc0YsRFqEiTkb0SSBIWLEYZDQyRMQmT8egTH1Ei1CzMJMj5LDOaKeSOgsNlilapnA5G1d5x/ZJizjjHYzVGNbpkGIRJ0ScjsQ8hZ1NgT0Tor0MwJ0iQnAwxGBImITJJE9B6GRCRhOTEKgeJZJz+47yOOwpllG7E/tEEtxiVS3heWXyhHaFurCpCMoeHgT1QpAWhy4nVCCRAsH5EhUISN0IwJGJEySdExuNBUKFnoWGMMvDk03fXlMeRyNQi5ko2xexSoXDFu48BvR+x0D3y/8AUq+Bydp0QmJ35MMmtKWT9PSR51QdyJeqDwIyUESIZEJ0ToQTGydCZHsoGpIetCDyI83TNvdEZabKJE1ZHPT5IRk7SuDhdwqX9jg5PDc0VNW9OYnpdWPQw45UbnBAlpOYnSPQ3A040TIxIhJInoN6POjFBv2SSbNhbH61kxnYXBAUwXxY5mAgePL+LOpMH1oZNHuLU6TKgYkefQMIcViwb6Dwhp1KLaRkToTgkTqISSSMMISDZdjczmTpMa/NDt2keSMPAgllimoGMY/5n9l+RERvATKORh+g2HlEiEMLQ1C2QGwcsmFpgdCSRap7aJk6FoToNklhuNw3gJ6XZkWEq3ufbSFIW5j2L8R0Hul28n+fRuJiuN0S2MYVh6bEmzRegPBeNdaYjG6EzbRqJ0yc6lq1oLQYElmg4peBOhoUicjCcb+5CDDldMwiEWS42B8LY6BoFdSNZOisk7gHpkWj5FhojDSqH0ImKzAYk3FgeghaJjYyYFqXpUMI0CiQl6JpIWgyIhv0x5QoS4eOSZkwekVcK/MjNue4P4HXTcTlPBxXKBzrv6RekSQ40ziMkRSWiFo2FkjWfQK1VoTKYuBFZOCwhibj14oQb/zJsjOhzctkbtex/8QAKRABAAMAAgICAgICAwEBAQAAAQARITFBUWFxgRChkbEgwdHh8PEwQP/aAAgBAQABPxD/APgPz0/jqcGG1AV2WiS8grQZeUy+Cc3sFWcJkSm6ZYOY7H6rOII0XK75uAQGcvqGAUpg5aGXG+l876l5CzvccMGsIp4uMPLzGdFNgRYerAFdX1NCfURk1vuTkP8AE/wqV+T/APElTh+IaJ2gnwe9h8gR64qAsapyRC0S4NSAvpFzD61kTtOOxwYlEDwwJTbqet53Btq1BLEtLzAiUTG6Mhh0R8iXByH3ZFdgPwCGxMFvrIF9IMOIOQ4//SvyP+Hn8EPxwj1MHXMIUeS1sDMUwZUVDJTds8MDqQNUrVc3CVpnL+JDwOZVzk8IZE+1F7sAseR2YF1WWwMUk9trINeXUqXVylWlMDtV6/FhzxOFc4NT4bHH/wDqqoCrvMsD2rFbqCoa5eRHn47joGpYWlFtz8Q8io4yBXSHiUhHMD1zzxxKQu08ARRSrp9BGHK3ljotdK2BwsaOyc7EADdv1U0IsOz5gpXPVQNKwNvc4KibbzG2kt0jHVHGH4CV+D/AIf4cX+a/zeGLUQoejC+DneHcums8lv8AWSwpda6vd/8AmBelltOXHSB1kOVZg+nbAfQStdQhee7hidFjnUctaWhtzj4+InVs5vqV8pPM5g8EAedvahA4ogQ14qALYVenmH9YC8zgGHVQEpL+/wAIEg8f4z8U3ZSVlYH8QSuwHUPwd/khD/HbRHaYRRDauGwCrQ5ZdtaCa2dsWVOiG2/3HAUctHjMIEMrZSBD2YDTX1BBahL7rnn+J3xK+NYa6x5AqljazqjuPnGZWoYuDkr9XKbS/bKnF/3GpFPFN4OViD8jJp/uAvUt2f2RcCjaCh9yofiT52tgKfPfqArqjn8AHesJgqXUUL2NuWbIbBxh+PKI7RybM+EfCh9KVjQi+sG1P4lD/A/xuOWXwYLKEzNS1Wz5lPC+BdstJwcEMsDrWoRF3Wto0eJyiTRAf7Pmd6GL5Xw6uL0F5h4gZe6qk2zOVQG5LBtwz/KATz/oBb7F056hPJ2ia4umKscbLZv7v5uIr7pOS/L42PzkS78r9SjBGvS35PbBUXorAC9DtJUM5lxDH9Ed/tG4hW5xiAox0U6jS25TOM+MPxdqzm7gfuIYb0P/AJnB9wVZ+4lcnr/6hYrc/wDOYtV8lZwqJdNRQsHm5DpfRIhAt0GCkG/8q/KQ6oXohsMQawKXZdqCtmps5h8fBQP0seMcS6LL4Ait7ZIkXzb6g84KCI/E4631c7yoBU+4qhEAugh10FVh+R/2TTngNV7Qq6imvxZuKG4zLPge4SaLmqt6SZvwEqysNA+2r5ZsE76ZW+PbC5XfIratCWi2ncrLZSCGAdBLtr+5fgOrqhV26YDwWVNRavcMr5JcCP3G85E4NKSZ2xVd7i/nZaHn/DzK+qhaii8ivlVOsaDN6oo7+CVUM4HXk2JxVU0Ys4z4KYFlwPJAQWWEH/IbDybco8Xg7aE/cZeXNpNrB68wcit8zhUI610L2B1lusNi0pAl6FHH7YjddUVf3qwJh+d/+j5Zs43aP36qZFIiToWhOkEuoOQb+YvUf93se71lrOpHstt4/Vw6q+JfgB9WyoxNUlicEppoU1N9m4nn/wA8lDKK5bMy2cCKXNOA8vl25gSSQhcD4cK6gUg/F9kdwulaCWlHtCl9Hj5lh7PvPmMn6OV7E4epcpQ+Vn8wM9EuML/1DkajANv2ztLm0Y4/laActUxEBpKbkFqnS7hdtyj+YCIt5Y1kEO+TsE1w+yNWaemLxweyIH6uixgYPVu0uUH3BYFr6e56445CNmzGED88XBVArwCZJESshWvzH+fz38x+nfBLlWJxgv2IWZ7u+WvuCkWgchePfbGs9QVFOL9XBt5AFjgjiURQH1nmXIcBHtmeDl9uXniUELDaMNvr65juXbtHuo5+5Tz21y+X1c7CF9uHPvmcH9Sn1Lyz24fURotPWVDVgpbcVuMXb4BHYnJTsEtE3NO1rvCWnrx2nLxOPXmPReRrK8CMbK5MnsqVsBx7L/ojxltq8PgjlhfqDVtAh/og6hPrEtUaalW1WSvyqZ+kIiJb585CqEK8hMiWeHLY4jd/EYd8N6TRusOd4mB7KgJqrcXA8n+kKd499QNdJcs6aUIUqnG4ZNxsz/xVK5lEdEVbPmyioBl9l9f8wu19EH8PT+mLems7IZsN87JNSt8QOhV0eVi+lKeDhz2xoIkFv+5nHC7d5P8AjBTw28UuCu183GUCptseDhbCgLCuGmnlfcrvOSjBvar1BTACbdPFPbB6MnxdFvEtjuQvZXi45caNj3h7lOtihtO9zUi7HweT6P8AuuSEltSvZMqeKtPbNaCWbxlr4gIUuhPB17mHTQ44XLre+GF4qKlyqKqOFhd1UHXUphQ6rHCH478AM1uRu5imqgWTA0tPvmB2gGZsrFf3/cfho3d/qcpB2ihKyEuyxijVVfMQqpV5gAFBXAS99jRN4evzK/NHXwgXgGqheKlRMAbBy2vLxf7lFEXQHwXw/UHEyAB+jiJqZp1WhhwRAWhQqtHydgJgT1kj5eImxV729q+IzWZL2l1X2sBmiHmesYXaKzTTxcY0xQyo6oXUN89LSd0B6OYEVvTVoHbBHKzl8YtiUvboPsG93YU4cokrUHZRGQBAtaNTxlxHpRxJ0+f4IbWMmrQizKWj6VQhOoUPryTjNXYBYe63YGmJOpxCY6M94MK38BFMGD8IrexAakihzHCBPD7hOLw4WTCm6ZcEK681s6bDAIhx+F6w+S4FyNc3HiRylvMqhKnGcfzUq4ivAYzJ/r8HAfKuAboU4u4er5c+2OZB37AM6gs+16I65SvbWH1DiKDCuuhOllkIaoo4KJcUtnK7i0LbRDuI66SGiKWMgAFMI5aV4panw8SkAwcftUVIGoctzXycwUC44cL5s2DKnsuhqCFeq9D74+4Ji3t4nD1vfwTQKdDiSXk1doLGqcrFtY2O/dH9xBYZuAvwabOEStwd3qHa6d4ShwzpSaL5eYkoUgVtQFRRGYHapOH5uDi1NJuq4Y288DD0uf8AnfqXV47IW7hRRUAAbTNOYtaVkWSngAcXKdQF7pVQOYm7GlnfdxaBWPURNypw/E7/AMBOkm3EN21AG/wwd+zolymZKyKwnLXuDZfatl+WNTQHdvt3KdxqGNpndkQrFeR6gfcRv/hj1+OnEUmQtU2E1KOTyYfbLaSqEC09cbGJ213tl8T2Z3yhFfIfDoxnaw3Wux73xKmDEXhKoMt3URR1LggLl0Re1a9R4QRWrVYuwKkjtGdJWPpjVNjNhUNEFdleYgtJcUios9HuUCuDK3tLX3BX5ZCdUz2awPviWpaGbcrfOerlm914YjvBz4qKDTiYrQEquD9TBWWFB3t9wYORxlROP+UJIqVi6DYoFxnBby4JELXfj2v8zW5xkfNcG+dDu9W/1MLPkQNiNDMuZrK2vK4H0EZCilG08RRIwKHBM2Arry8zufjgsNKm+KaCzYw9gNmcnuCV9cMKkOSpE6wxrrbTPRM/6/Ki4EeCcHlhkxzpxKQM1Rv/ABkPMWeQvfs9R487Ao+LdtcPmYGcU2ElDSaqZpK32ilmkXTU4gmglP5xQ47JsSYMd4V1MXLePmWMGnG+Y6Bg51CtRWZkwUquSpQS2uXcT61l3BFKBoU3yVU2bnxHiOUyXuQtfnX57QqGcxHWTuWcG/EYfWnUQDA1cd4iV/tFXyK/6nntJlOql74u2/LxKkQUxV11URC4PfMu2B9uUmeLqK6pyNKUPrcYyV7Ql5+dBhVcdXxVSvyg6SZrbxRlcKZ4rj1L60WkgomXDtZvS48Kg0trpQmdZGWjWjzfMSmyZ2SN3PiDlr2xLORwRmm44RKluuKg/iBRFq/wV7O9jL1fMKlC9Fq9IMsA1DRqyvEvHgR3vnicFUs5P88SgxeLl2FQw3rvIVcCuasgi1KKTL8a/FQgud6jjlFg7UCjjTb7l1V1YDDRt4Yh7tUi7BW7RmPYy3uqdfFwyx4J5hTVsuhtno7g2WN4aMNFi+SHoKikl4+oByMOCGMKLr3CqDF6IpaC9M0cLxkEipY25Q/rm309StGMnZE1/BMTOSUlZd2qC2ood5pdvEB/fEUeSLTyEGCxVjsMjD8eSHzYcMciLGuY1pRjKyZ+/uWVlDfDGocvmG2Fo22w/ZElFszWaC0osqnqLXKQ7jD53LjIbsaqC7Tgf4ahHSpftBtfmqjlBoV3uXItv4KWWb2tazNnEC/mnZXl4I5Z7qJ30XlufcYEmnZpNs3dqVZVHfsjy9/qX838NhOUacwqBIijyFe4Qan7hPbO3uLe6G1HKX+JVs570rA9cQFi2XVtQbdyXVGPxbK9Ug8HMpSUUSlPmD42Z08XK0+okDqzlxLSoPWxly6bVhGBaO1QEu3nMIMHj3TksnYMGV6VHxWw1Pb4I3S/VSitL9DKnhI71GBtjucXN988R8SihS3MnHZw/E/Ix3HNRQ78X2G9RgotqUfOyIYt5xI1An8sG1KauKWT0rjIqC0xUmzzAKdDgsHhK6u/3BunWXGC1sKiy8Wc3AvguD1FbrNaxJFmmviLkiiFrbwEUha3J7gstQUOGWp/wdLiWrxystgSrb2WOiGHYcr7ncjQeILSDI6ak4t5jriL2otj+ZUwMhfbrNy0odGRK+WE3IdCjfKwu1TfLCxYL7Y+DjmWcKCWrJR/aQdzzm3DH6jz/IK3CMDHGyl2g8Pi5w7Mka+mPSy1tFfP/TPjXqROmMupT2x/WOV+opdW04rch9GNexH3TWOr+YiOP7SW0jUondtPBBsNYe3K2m4J2nIdhbGhfMLjQ/hJ3DrVcl5/UsbgVnjogmqA7LcOgVW14ruLeaz3l1/1CNw/pndW+bla06hSDCUNvGESUPxIvA3sKasYUYzJbX5iCMU7/uX1VfNQKKBuLKzVHt2Slasr3WQ7y9OHxANDiejuXjLF+Ag4gkGZWcR3vV8xQo1cKdn4H5IsDhm0C/L85zEyVWh+6S2VKKS2vGTjSWbDLPMYur2ub+0cLMGG9s3f5EIVdWLhn1gTUFSDj/Zc6eJa0jgVTpGucsofMeIoYyPHEWvFbPIiTh+b3sZDFtleQoX98SqcLv2h5gY1ujeUgc5/Jts5Lx1ewGQbxAc4bQKmfMe4okVcA3JvLeI0G1coUx3zSQtfomNjajhBYujMgl3kc+JzAF3ewFDSddQ1pcZzCjvDmidum93LKvk8QtdlnUO/CPRyiVLY+cqCmpk/Ci4kgPMDUTZJ6lk6Zcg1ICyNkmoXpxGz+ExG2099y5c1anA2Kvb87Ck0iGA6hG3bdFH6Y66Gf/IfqH3rqQkogto7l6Al8M4q+25UQJXPj3KU8QrWuN+4EFcKH+4GS7D4EIN6bZEvIsR7eIFAUHYdDOKNmfaZVof1LGXO0vyxg8KjB5lUyxhEbNfSxcB8wtAJDFCMIDjdqV0urL9sUBU91FhOb1U9TV49V9QwUomFMUOHDNXXMsEHzTFa8yla6ye81xMEXnnlj0UtSi3HGVkrrClK46ViVwEFLhyyuOzo2FdsPIeX4qIuadcuWrIafcqaocI8w8xXkRycnfcBO4gDOVROWpaZehG/UdWD1yIlbCrZtw2NfIhgJaJQvqI05QtqWElVCckTnnLnpSqcPiJRXsQijJeXP9ovp/uNGlhxPPCDfFS1f1Loy3Q4lpdmEat1s24XKOYCOkzRwdMSH1wLjYGzxc6bttioFdqhi4W9wvuVmltEAg1RzORRXlRKth6JbunYDiuGXE33/pKRfqp4wTqcWGnM2FY7/lMsayE5RnFOd3+orPAt3yWIXXpbKBdOko2E1beQg6KphCIA1Yy9oXwkXYvkxnyFadQb/wAkIAxCitZWIVffZOTmjSH45RNf8jdwsvrJTzVvomEltU+kdhAUruV6i7ikMLChQ1eqxySeUlv1LBeiPyIsza/BaBVMVc3brLhexrfsl7eoEGo4KpnFnh5eYSn98syRTfAQC7OBZ5lIcG6yXal1zKv0c3zGCik6MgHOcEr5bCDS+rI4FrZygxlDOE6nBlfhYuhiqNofyx0tDWMdVaqOFOFM9vTNuiWHmVPuqoq/UuwT0xiTdGl578Sp5Ab8ReoCaMTs7L3gp6msOtIAhEQFWyEjbECoGomvSo/xMWAK5nb/ADLA4BCmO5OIf1EasKBaN39EqrTn3Vyq4hoh2EYI6YOTPBao/Di724Kg1tSuYmJsa0N01LUujqyKFojqhyXHJVwt5gTVWCpz9WkBGk5P7Z6IWjEQOpa7KgjciujMleDJ1MKfuxvE2XPtKs/qW9pa8XiXjYE+4fkvdeYOWC08RvmaDAKq/wD1lB4BmCcpqbVOJaQRAmB3Arz5gSjKlFt8TmAteJk5r149wl6c87LAEFcqAVbImEb1IoWwknhv4E1W+gFsPoqXJ0K46IduQO0T7JxJPAi0uofB9QWAV5mZDvezRMq7iMMDXfW8+ZdUAHXicMG/08RWtGinOWZCsireGErN2sLXFeydHbzktFsmc3GvfOVBTSPMEKFsaeE6nBj/AJY81JyPAfphkKi/DqA44LKtxGDQ+NwN7u0yVUScc2C2ybWV/wAk3yzn/tDfa+Rl4xXPxGdWlFP6Q1sSwqIGHXOwq0Ky6NlKmXDpyOm8surd5KKDZyvxK8WweQxY28NfRHdDfIfPzAb0C5rT+l/RLcqv2ZTjmG2USoYQ15iUh6OOYpgwgg67lfohVYPNTjHmVkq0QLDHpy+5rTWr9S9ouw9WwtC4cHNkZdYh9uHL7gC7M4iUKipu/axAut5Rm6gq8wNKUxjpHk5IqU/cZshsg2wv4vP6QwbYzLxhWpyrPiUp9S8KXIdjEjVbrjqczBNbbwMtE0Vs1fEsVyVsrC3qDFEKEzw9xfPtPcEC5bq6guePTFIUDynMbvSmFb6RHpjfcSAmQLaS2UsQms6j6r74X0dRAkRre73FSsK1TrxM+M5ibHv8dbXaRb9dE0c5XMTcw3H9ZrW5KpqdivyrC4k/2WEmiU1Z1DWfNx9XfxcYAGVBC64iEigAAMCf6nsZq0l5wyobZe1coZtvHEbxOH4woh4rmPrgme1jAq1c7rY/2QQKaioeZK+Qeps2gOvJXESNhYFtNlgt0JTTC+mrpt88xMYdk+Wc5zcQ00NeHELlyg6LmSaM3dnKuaQ7WdfgZim+Yry3pNC6lXFsD7qHu20k8W3Z6upc2bn3Kv66iFWLcHouMXzcOikCMaRPVQCrfMZGikgtyXk9EqNJSFkFtQ6grCOupD6FNy/Th15g3y3lhPRNZFZ29osWtK+oNuvgjZULeIFSz4mDfKVcHK/uBZ3Ko4y5tQXuRe2OTB4ndA+jhuBbVYru9QnQFVumX34U3sjjVFW5Zds2sXJeM0g2eC8uGqqBYQV83UZerTNBw4xUJR5rj6jXjbLmH2jR18rQw+2ppPRl0GeVy4B/iB21y+XCVGVXCg1wcwKxlMw2KEFQYgAfEMpCHZ1MEqFf5hdOCJpuBXCIXHzLxLInm8UZdZKHDOc1RzfNRsr9+EreG16xKhauURG6sp40c5ha1aNNPPMQtXHlbDI4UUqe4LaIlBa7TAR5LyPUqpvmFeWO0WjwsJWnUqavIfBZLSEdfmMXOEJKbmTYw3Q/7jYLaVX6lKrkaaZVsBBKtFRIFaN+i4NCV2IhAAGriGcVstXE0CXD9sbunzSByng5QKJedR10hCncO/CoD5qjUXYJTOJTqYtQ+XRG1JTGmopu4aEsvbnGXAtsaK52o2bdC/3NFOlXBNmMXXLtLjNMCwaK8XBVVdd1cu9ZeYRbu9PRM0Kh6rCZF0SiZpzsFZxU4zqPGpV5v2nFSNdzYwP4PmUvK7e1b+mEQUVhZA1Q3BeI6Qjg9oDLy43mEtSzxfEQL5zvdea8sLm2HIdq1L5gmbLsjqCRq/ibYlczAOjuXTH0V7i4iKo20/uBLXrU26GGCI0yTO+SCqlsy+riVrtVBopmRHcVExHMnPgKyo6caQvbTpPCLdHzOy7+HJHYIFas8FmTBYOkQe37JU6GCzQEv5dqloOBdmcMvL8ShTuPJeRQtbvbg7H8NwRwLQ8j69xy4S3oAtaiulF65Ty1S0VKVVBOTwSUlAm7uFWr4PTuYOloDiCqW4TWqV1riLLHo3uYsBv8xRop93UNaKZ2YTjFtRHgMqtTWq+IZTB1WuNioeIdTnuCwDYSELFHKIhckC0Q2g5mOfUUCqg5fphlOTK6FMoCoHuX1XZvFxq1bydRLQQZt535RQB8hhbG66uMtunDUEO7nxUQctPctG8RqmWsRXm+YvLQ0QPLb8w7wMRF4ilo3kpP3P8AaWNr06/YcfuYTcV+oFptymwh+Vv8QGkRRhXwUQVRAaFNA7pX7YPZRsaNv4UM0KUZ8fqVvAPAzxCCbb4nGj45S3g8pdVEcCdZhopiQjUCACg+Sc9goIs9It8EydA+Jk6u7fRE65dfFRYxe7WXZFbcCX5bLRbI9ZtREwUXwQGwGVAFVXWygLDpCjFNqA1AQFLGls2B2hcWBrIYc7j53FmIN+YN2eNWLi6W5XxcosJihKeZ2a3viACOk+I+Pf6I2Wmq8hceW7cUgR3JPa5LwAmvD8v/ABOCzhRfyalzZ20G0vBr9RncKCC7Pl5mKNuzmnl56ZXv2lrLLPz001tuuOYv68GiHy4qCTFKilUGIrt8BCIVxCjmBs41nMvw2dd+ZXkeg9w3TVuzeQnAPpB1cvaGFYNVySgKu5se3TKLhVOoFcDZTswsC7akLRYHruI3ii4LlxQmxM1Dzkq8ujL4o3kErY/17l+ndiAN08sTUSJmxbC8zhn5lHhGo6I2HPENolDqXW4AuwAFoOWJMsvtfExkrOMPlVefDL1tUdXa7+oTY+a4Y1h7gfueNK5HiOEcP0e4zS7v9vEcKUJyv6l5VHH8wUuWvrC+08EwDjwseO33CFFVOHiiCuerQJ33OBeqFujlc1l8SpGMLzlt+kriZ65MqLAXzi6mJNyunWUhs6pS9tg6xBYVye188MUIoApMu0IN64vYoYfcY6KlrqkTmeQrMXi15XPyyvvdY6hfWMq7uK6hRSOox22WK6hLh7YhEBYLonXbpgBQFs/lWZRkBx35lNZWY77VJPS2lYljGxL99fu+WA0cMdVcR+S6fUp4pYIkAUp4uPLquI9+SWuTTjN6MdBNAhjhm4rOLgsxZu0m2HRtzuDeCnipXqodxFkNpWfwxquD0sJ6j529hQj6Li11bqR7sXBePiEa9SnaKDrlDM8t2B0vZBk0NSHRVQsNXa8DUETEcyOa4rYGN9tWejhWVrA/Yqtz6v8AquJToUv/AKW+jg+47ndMgwNJ3rUEziwQrpRR1OsXhV33ccPcKP3E1y/kR6Bw5mcRyswiGQ35azyS69WB7IO427Z67UcYKPdbOauKKqWqiH52eIeIL7zLnRRd2SgYO8wSJcsVdXfUfNYb3shu918Wp95aEiwmeqcF9w/jrty7tysclU9NyAtuWlWqCXCQVVWwAPcBuAwhe6Y0BWzhwKtOZmnByO8VdTbeYLlhAO6PlEA7gGO4AWPHfCOy8Vbu/MMjLfEzrhY3VEe9qGMD2AxBhmimBcrT85GvBdQ9R70cOagTpSoGr02uTtI4F28Sn9VsMKb7EwTjg4DjjJVdJHVIr88QmkBFGyW5q8LG9QoJ4Edilp0vmUxe26a6hqzwjFvrDkstvk3iJttE89xyNNziFJYYtdrZYLD85cJE3xsbiXHPmKltsByir1k5dAQItgDk6sH7ZuxXiD9VVoAWc4ABzSK/VRQx2ydE4EcXmXKjFYV4Q8wTMkG/29L6jSz+X8LxKNVdzstNnEC4WWTsje2EXoSPG9vUshbxL87L0DSHmMaMnIfEsoMy+eIwqiA6eniWrYp3tC3A83tHUtfpcKWkjlliVqV4VudbNrXtlnbjQUgDQ0BWq8916jBNY6NatbXbOvB2TG6fDn/UXoc2uwpXWMcUtgm7tL2vPmLVW1F66jy4KgZV1kNNJM3ovjzKbSCwHrlOYqhu+PTUaYzUA8hbe3sgVa5wjK74ViVfJGFSQbvuYFN09QcpTL55NcRrsoT4YlWF9fxCy1k4jjmVl81b5weaHyQOqc6xTelXcsLIavPz5+GMW2v41NPd/QlJ/UFvNeAlLCdKKnHRUtVq/KWoJfH4whcL5lt06kSRe9IrcvfB+pxdGypQnHMzq1OB5lR9RBw8UOBKe8H+P+YW1R01Nq1pIyHuPL2Q13ILaaL6DUJzpIXxs+QCzYH+LXFK7RLqcEalfsCdgwFVRyqXGhrajfFnLcW/Yw/aMpdXTCgs73DfCCiwFEvmrsqa88Sy0tuhlRsngU4RWwaMLzHuio/rgLoeEJccQ8jGzaSbZvRKihs7zqEdDGbrAI1I7ePxHwIF20Shx40vu5Tg2m24oly30SyqWvNzih9yiLgZcFAlG7+mv9y0SH/8zXfWPcKInCKWC85z8kRQWueMuNbbjkAWRQEd8QF4RCAo2jUqRq+PMEVe1Rje/wC6lTG7CERXPUwrjWlROHxFBbX1xCFyn/Efjxl7H1vTxLDQpVVjD3Dz8HoFCWIedyNNqqFUDDMXjxKUIj0jSNoSh6aniIzmjZj1tP8AUudQ0cl0GNv6l2c3NbfEfqpXCvmoGRhR4i2i8y2Y8rtHJANPMo6llrh/p9ywCAO7+EgBap2LBRbVQt30eYogBdCyr/uJFuQ2KxnuD4tPH4L4ivE+vEeCFT25U06N8z+yYVylWxda4ns2XvnqXPFiQb/+RsnfvyDPZ4e4o0+bA2fCNUdRaUML1gUlrRw8SlMLpW+TUeaBDtpemCzYvFTgXUKGVRuSyAv5Lb8RIVRS6lAUXttcyl/YcxHlpVdfqD2XxopfwIWBMB5ZZgC8MmRqEb8DVykvwpzW/wAORw3tRsr15io4io0V1kpxfXDGUgZLsI13hKU1OW7+oX/KO6v9s9PMtZbFuXVXDN9k454Jg8J2epwbwLW3/vee4cUax0p7GcY2qtrkYqzuYdR1kOlqplscvyODlnlb6dno6heu3JXbKWjIlt59hOTYCBxoKlKyhS8nGZbUaDyl+GA2eRNJedHMR+vfr9kEkWwFh7EweyIv1AbyXuVQrzOyUSzBr/UuFtUbCOoBDQazrjmE0cv8TCD7I+L0P7hqWFV8RP298eJZl78v+hdwuuQXihpYbLUmAgira/puFmCkXGDdeNQe6ZVojmetL/k/cxX1x7nwDxFV/dp5uiJbti+fqA1mcsra2m4lobNKHxUpcLjmRwso53mCLFCMOOeE4lvDBiL/AOzWfxBK/m118r/TPBjma/K5LOZl3H5cjGDtvLAhdkbQyK4rs2FeTmFVxq3KSpvPo+psxxzK74qI6UeUp5eLi40CofLxMi+vzkN7/wDB6lGtvpFKdlXAA2Bh3EXd/wBMuPPHEFCyoPBrqoZ6h5HuOvVsIWUmfcIL27l6C0R6np1zZ8lF2Wh6bxHxWvfbL9Cb28/1ObbHEuTgFJcVnRdxAXCDIf8Ay8yi1jFSABUZSSmm1AXP28MOty64gqkFj5YXWMVjUs+BjnJcCuwZgpnqX5ZOFYVM3bvxGbA+2cpdIEG5sqzf8FJP2geY2sYxVfEPe7hUjG+wPuT30e5RmleG0t+OYeDGgDbVPSfMpP5fz9Z336Nk13iS1qu9iLoEIWbY4CymUlb72Z1yJYpesraBdcXKtmkCA8HP9wlC6k03+0pA5MN6No3zoRbirqWGYdar9StHkirXbRlHMWKLfvqLU8xvBqLTxTObcnm+O41d3EfgPGltyWviNfqG3ac9TsRkSSyeI98nxAdcGKXkLbmMZNxIe0Tm25QX3Cb7/HlIYsZQ85f4TlLZpGh4K7OeXKlWMP0QR6G6Zf8AXM/hKfUqdIJmYVyjaKKFJQVzyTgbB7njUINYEK6JfDHsl1YhAFN0lv8A0y8WyM14pVRQ9Cv1FOR/DEDnivLyxXFUWlVKuebYpni9jVUkycIxTUC2O1H11Qn7i5OI13UosxjxuUR/qKzm2IqovQi7cVk0uXT+p4KZRUEdQF0wYNXtw+y4NaJzmbmUDtTBv5B7YaJCi/jOUqbZZxBXjHhBfNWl+pcbU12saxdfrT/CxBtWqlcN+IqG30Kl21icQ2q1Jbj8x0pFBytdwzx7UZha1e5FtvOLpG32n6hhAq7JW9Kqj/nbnASlO6sNp1aMXpUPVYUf2QbMn+/xYTuxjts1jh6hPVe4LLH3OaxyPX+4N2uBd8eozhR2+Cc0oWixzWJGi0gq7npxkN+CZQ03H4IW9wsl5+Fsp5YmBusawtjCpZaxlq0RIowu8KjJOi4bbaCPeDLmuABxyR0/iqliLH3CK5c4ku6Sj3xBo0o6cxddMu0uTem3X0qBtYSUCbRoWp2zXDtXixxHxCbqRHqzf3cvpdx51kVdeoSdzPa3Ekb1j9ywjwZU9OSKAr8NVJZAF1wH4i1xxHp44g/YR60sQOGP6iPZUxBmf/aHLjkJZ5KdPwHNnY32A3HrczPqO/BFUFoYuG5zLxOVGoxZPgX/AGMXPbjtimGlVx45OUuoKkfs4gOeIul3/wBwAFcmRO5ZDS4H7mGPw2dPWDwywspWa3/fmXZzUZn3+syqXG6jjpMIy1Y7u4sgjVXUoP8ATC4Vx6iFc2wM7zicpZoTIjpy76mYeOyKPTLKbqQq+vwGgs4bgY7ZCpLOIe3HM9pdS/uCIItSynEYFbtfwjAbQnazkHuXE7oj5mojv/sRftxc2QqwWipMvSjN8TnL7hTC6L/uLtu0iML0eTq/nV9RBbGlA4rp2qBSFKFr3QmtHxPrfMpRqco7w8kHrgi4OGFB3C9xxbk81Wyv9Q1+OGAhDWQUNEnCjXkgDdcwHKcwrSFQ3FBxBbO4umc+aeslFOL/ABI0bh72wwDDlHkXLn8fiZfqNFhuWVlCW6JW/bbZTH8rxG+bAoZ5+av3UA5bHDwSosNzqLVfBjSEHbGVK+lwjZrXzBPC+JZelh2aSuO45NQ0D3qxN930twcKK11ZDNsxGUrh16J7MLtqb8ykhvP5jdydUnL0QDuXK1OA42Ba0Cz0SqtMqn9aRy4llZGfbsK5BjyEqGXMKJUxSBfxEXomK/hvvtliGyuAsOu5b16QofqakQHwXG4U1T0K/qUHCAexITj1UBOebqYPPjP3DbY327bsrah7Ir9hnkC/oD9Ij40PVQWeNq/hiKGueLH4lVUuKf8AUvnYWE3KFIQ7EX7r8KCpNNI3vmpTyx0tdlcSqhlWDVxcfhstbcwSXNee4IzS7JVlG6+owRthVQHbF7o4hBSvq/xB1soFaa8xMZrLr+VgAk4utltmoZOP1Bat2e/Cn+oJe5zCnTN42vHgj1WhOWUDHtZtr5CkR4XlARq+m+EhBuurDoy2A8FTSO4ZfzsbNYNFzdg/clPWs/SOuCw/Hzdx5F2w1ccZHUWcxIGsIbobUa7q+oucdv1MQZuLw1bwxgNMfmm4htW1ErUHnLnmaqFxuer+FsSn4NycZp2baPfMsHksr8i0Sg2LhcUdqtJRiXz9vzp4+4FTgFtyqFrluARC+WNboqwZctQLYgPazE0PnUrwQnabKQtHURwA1rh97UtXI1lHY6WmPDOWOwrly6Lq5XF5P96nJ/G1SvKYu0wIDYx7vTxG2rA1cqE8xb89lwFZsBb6ZestG4zuEQ/HaFrDM2CttJ0wb3KZyUc8zhrp/HaytTdZ95CR4BRCHMsvw1dBMk3d1Qxy4yrridvnmckrPPMuHTWvuIL0ofJy+hhe6IqGhn7gnOgWtwGik179XC22B+F5LpE0y+Yfscx3ITZSCPCCLNXI1tNy+HxAalCnQTxU7HaQawxUvROAoYUIrG9s5iitcs0qWmGR8zQiol1dN3LmcMovogkTMh8Sq6ZrLm31Hdb4ZtlEOXmchgHqNSSqWXx7ZhdH/Yf6lzsV0b9QnA+Y4xLb4EtyF9xoJ5U2XfJuZ0MTkloxPLWj/UH2QUo/UY3PE4bexW02eRC4N2Dc0Ut25esSUu0uHMGzhzHtVkDJlb2FMjO4IReGOqEVQXdE4t7B0axptj7Jvj4qCypbFPLJwY03xhHn1cZelxpLyuIvJF9DzAgsM/mJBBTVFwgOI3bwa/iRBA6BxCtwoPrxDuxJ2l/3IC2rVXTUa3HKYwQCiUpRtIi/qf/EACERAAICAwEBAQEBAQEAAAAAAAECAAMEERIQEwUgFDBA/9oACAECAQECAP8A0InIQKEVCnyKCoVqIQq6jhqzUKjUK/j8viKmooRf/XTAAogAULzqBdMNEDwqVIC6VdFREjRAPNf+ipuw3YftrDZ9S/Zu+otNv1+v2Npua/6i9nFz3JY1tLr/AOoxTtZvpWLKWIjwCL4ZqLHCkxAwgAGsYL/6jEVZa5KhECABOeLGrs18hWazV82rFYQIENQQJxWB/wCnc7DtK4ck5f8Avr/Tq/RXJF9t1TJbTYLA3XXW2YN0GJVjEg937ub3v/q7As9lpsDNcjWFzVK8izOS1shXptVtmMxYMzo5dT3tpRF9ECCooKhUakpZFb/mZfYbMjMN9ASs0WPblGurK3bSlLnGyzkYuTW7Rk+XyNXyNRpFPxamqtfUZGhizWl8Qf8AMzPP3uupqx8hM2zPuvV6DbQqJcbueWTFyqr1yfsWNwAXe4AYIPVVQECqvzCKgRq/iKiux/bTKquYSkXoItN2KZjr9S19tdvJu+4p6xspLxYp+wtNws+qOz1OPQiIQSDoKq8BQvAWxf708z6bDjZNi0oDkvTXw4Sq2nFYwutoQNTKkriKV1oAJAtMX1WU9GKxKsHDg7DAux/4ZVt92PhW/lUKDfbStdVxoq3lOhqdK7K0JDmu7GdVZQvPIUKVUD2sTkKo0URedCFSHmx/TnKyQcanNvujZHWLWC4oXJzcelMaA3jHVoyUWo1F4s+rWfbtW+gceoyspDAsSfBAAgWw/wB2zLP5VTZF9xAqrrVrL2ue5HL12hwb5QGV5XBbjnYhAXyy7FUehtiBxN72H7Ddh2JP9XhKa68ukIqGK92Q9vZsrscpbTZW7BFMKlGTGeqFOQqKUXGRQPAnM0BpQV44AKy0bH9WLi1GNXZGjx2gUqEYQrW1RCAEsTCtTUKPNjxAB6lgdC1iEsH7DBgR5Yzf8KqjLLLGctLkKivQJABFb1FGUg70VVEWHwQRIPN7UCbAI1AApPgew7/smy2yzvbN0AF4jkxii0is6X3vBoQAEeidCwu7VwkRQoMC6A0FUFbB/ZmXetljpkdm+c8aILdMKxVGCOIYxRMZAsJgGo8XwStgQQQwYWddBgwbuyGD+8ylvzHVKnNVlVX+Xj5sjiOMY1lijR4JioqAGGBuoJYANaVdAEJXwEVCor1oSzwf3lo+WjCnLISjDtqW1bhZCGiSsytQTAPz6wNAMCANCWrzAocgQyuGBgfBBCHH/CyvI/Lowsk5AREu/wBduPZSXDICrLWVZWRnnX59OjX8xWtS1CsI1bgTUA1XBCAAdqTNiO2x4SXFqvt8pMiyy2xwa1rNOhQcVa1IjSsi05K/ofTGporURVIEWaAIsgGlQGaQEa0FCc6log8MaCKcnJys38xrswXsN0WciacMPLALHsSqynAn50V1s+n0Z0s7D9l2iwFHBWCVk2/Xvv6d725g8Mfyxsm53w7MlfoLxbjXLaXLObD0rz4WDFtvT8+vEpaLGiwlTuCENNRUDLCiV6IC8ldQCwCDwx4DeMw0V0JkV2Yq4xQLXb9/qS5aLKxWGrGMZh4qVcIhrCcBOOQhVlHgMriRYJoTZXkLq2CDwxoPP0aaawllhbZayAhhOrCQkQ7QFfz8SqoebYjwHYPjzUVhBAyFmD99b32LLD6Y0BWfpUYmOhuoyMO1HyK1gaMQXCshqZHqpxMeBjFjQQlSGHhjQiBQoRQqtDWAVCEF+2iweGNNiZVOGt5JbJMSgXkGAgljAHanFoxcTEC8CsgDQXhRwqaZT4IrkNFgJnQIZmJMX0eGMAomlqy0FzZJvLRXdhBCSKyteNj0Y2hN6Po/geEP4ZXCvPzCOAdER4Qs2IPT5pRYt9d1dlDV+gbEQib/AC8XHp+n0+vRcsG2D0rKwbZZ28SsV6RFU1Gg1888cGOog8MJ2Jqw5d6O80DswxSrl1ZR+ZWCPDNhy/XakxSsAEJfzYghZWU9CM0I4AMuX0xjsP8ASt/0MX7PcbDZ9WtNnYZCBjylNJ5rjTKBpZoKkEEMf0LWorRDUVWvnWmHPF6wRma9rCxGRb+LZlC3EdCeticckAIPzqzYjh++tmE61snYbsOzsd9LCQQBGm4IYJZkWfpvk/UWqn+T/OmM9WWPwJeXlqXIajWqqqoFAn5a8KnPVcJh82p2DC3UZu1PglakOqqS0tybc9n7VQlKivjkoFuT8dMln8tU1mvQCgqqImIcWwTkKomioGgNKIPAD4BFgVV44Ws15mYzwIcaqr4/HnXLCX1otzsQzQ1uu1gBgCLRMOq5ZsNvreySQ24YRssG7JMrAJfsPnZzFKsemqhK0XXg8M06Z1bsTGjOWEVQEHNYrNac2qGDb7Ldly297DMTH8AIWAjx5lZQlSVqqgAMPNqR4yGWLkUQhDapIhgUBVRcCgDUKGtXhhOvRN7jwqsVRDCRLrqkCVAAgCMBCBNgDxgZfVfQZ0Q9YUAKoRcbGRFXUWGFHqgh8QmKd7IadBwQNoJmRZXOQSFmzND+ATCIwvpysUq0JgCrVVjfn11qOQIs50sap6+OAIJrwxoPRApQgCk1geCATXgPmtWLplZb/wA5sX/IuIMXH/OoxAAsIAiACa1qygQkfwWLk7ml8Exm4UcwLF8Imh6BpvDCpV6f8H+OvFVQvCrrkrpAV1rmZECOuoA01yylAYITkvSNCGCEbUQj0gejwzc55CBedaAnOoo3qGAOcQuNahEYQgRSAoulUEPiwQRQ3gmiIB603zyAACBwFgE1yRr+BHNCXTEV6ueSCYX1GPXVZM3s+gxoIZqCD0wgQDWgsEHggmoZpoDs+ER/CvQPTwlSW2JbDNAwmA6E3rcHg9BgggmtAaH8kQwQwQgjwwnUuUxw4ZtmALLmWKEG/NmLAY0E0IIJvewRE8BB2IYP42YpJ8M1CdCGZKit1cfM17C6eJFI/kQTawwwfxuAAEiAhR4JzrwQwzREBIhhAABFyBHjxgVALOdgtD7uAibEAPgm97X+U850JvQ83CfCfT6sMI1cjiAjy1kgAMXzaiAjwRv5EU6EBihSoEA1DDB4QTsgQwiATQlcC2rYC4miWiTW4G8EAHuzBB4AIAJoD1ZrWtaHm/D6ZsnfihWBdbj9PoJfFZfRNjwEQEQGGMPQNKND0QEfzyRqAD3U1AIAVUWy+fIIDYdKSfQSB4oXzcMPgiweAaJg83uamiNGCCGaBJ0AIYBFa+WKUmySVEVhASFMEHgPgLAxAAIACP5UCACEeiaIEJMPhGteVBqWoOM+JcxYKvg91sebHg9EYKNweCa15uAw+H+CNEHwKoJ1rWMqVmg03Uf/xAAxEQACAgIBAwMDAgUFAQEAAAAAAQIRECExAxJBICJREzBhcYEEMkCRsSNCUqHwM/H/2gAIAQIBAz8A/qLmxveHVjpjrD8DGloY0qxZvbPa2sWhuxt0MslstMfaOrJOIxpuy/6vY8KqLuhnzitlM/sUzZZZSaNMlZs2bKNNFcGma0UXs2/6xJvCIiQmIT2hNCTE0KPIuBMjTEtMSwhXsSYkc7ErE8LtZ8CcnX9ZUyTwxoliSY/BV2O7Q/I/B7djY62NDSok3sboolLgaW0NpjrY3YxpXQ1J3/Wd0mkUKu1M8Jl4jeiNiFWF22Qu2yMloSVCo1YkJCEnspl3jRGhUxC7v6ztb2SaIoUtyIx0iSWjqLyS55ITINHT+T6k3GPB043asqLa0SlcmzWkITWyNbZoVisiIjVWKiJHYr/q9CFFEnLQ62TUtE3G6FdSIqjpNWiDTXkgk1ezsjZ2tFqxRR7cKi9DSJXQ0hsknQ62SdsdD8Hufok/JJkr5FtWWKuWO+WX5HF6L+64yoTWmdsrROb5pfJbuL8ilwjXAul/9GdPxsmouZJQpkuo21qiDlUf3OpGNt7JLfg7tMhFcibFKyyxnuG9Do/sKsPHbJv0scvJTPaJ7N0UbKtfdpI7FyOasddzIdNU1wSpvwic7jDkpW3simm9kOu+26KbS/6H0tpjUrsck3ITjcmNO0ztgds6TKW2d0RyZS3yJya8HwOsOnh1hW/Qlh2XsT0UNIfKZsTdkq5Jk14GuV9lT6bsabQ3cWyXa1ejp9Pp21ZtRKio/J0/5nwhy2lRFe+RGbaqjpRtSE7S0j5QpQ+pL/8ARQSj2u/yjufv4OnKkuDtdVaQ53hz5Yo8I+eRu2UxlaGXtFv0Kh0OJTo0kht8iFRss5WPKLuyvsaLk5LySjxwR7O2Qur14x8R3+4/qW/mhbZ3rT0KXL/QjFNLkqb+DqTttaHHTlwdNWR56f8A79CbSt2K9oTVxO5UxKVJl8FaQxuWx2NspFLHyPufpqJ4sR4N7ORdpZo2LZo219nVeCN1Lx4JfxM9cH017BRn3SZ700iKhzol1pce3/Ak/ah93aiPc5vk9tRI9SX0+nt/I4N9OZNrt7eBvYo7VsjCNompKR29RURIrXk8tC8EX4P+iNaFRoRUvRQ6Sw9jk8aH27GxooYzf2KQ220+CXVnSXIujDtKVJ7HaVk09c/+2Lq6uorli6fTpiUWyUU2dPpq62Ob+nD/AN8H0oL5ZCfV+p8DfI7Yl0nYpKLb4/yOJJStkU1oiqlZYqtiQjVYQi5V6NaFVCejZTF3C4RovWEzWsJfY9jPfok76si/JD5HJ2iCf6kKprRKct/ykWqXAvLIxjYpO0ytNioUlhyTSeqPp9sRNM1wVLaKkiMiIsLYj20dronXdLn0tFFY8jzWK5LQr+w3E7+s74Iw6fahraR1ZuqVFIS38DUF+RwgkhuWNJE1ROTGtMdCaLE5WJrD5E+HRrfJ3IVZ2LYnO2UvTUbG+Dd4TYq0aEc43Wd+u4tD+u8a2R4HbRcXo4VjbxbOTwNWVsZrHg1xj4G0yUJ0+CojXOOR0b9StsuJRas1tFMo9toQhCtuxC7jf2K6jliK0WVopcFvuQ5F7L2xsRemV50hngvTLYiJHZ4R3SpC7UMZtjQ79WykWikWlWHhkuRj2NOj3fZSF4HV4tioq64Int0W9IXBvgl3Wmc40Wawu2ilRTpFpyK0isu6PfihYb4Z4G4ng+D5NloSQqwq2xcCN/Y0ShLfBLqXUkTim/ArFyd5aoTVDjeEtlrk8WPRYmmVsuJYrplpo2VBI3eNcCxv1Mk1+Br9DQo2hO6JfsPFrZarK7mb+xOfVpD/AJkzqVSkdRyetjgRe7OnMp2h1skm7LRT2aodWPgdUh0x3RWsK9in1V+CIr/IkKmKhG8Ki8IZqhDNYorNpqisNP7L/mYuG7IT0lZVsS2Obok1SkfxfSVN6Oru2dRpl74FJclqm8V1Clodfli5LlY7bN/gTm6LN3Ra3hUbpj7rxaPk8DIo7kqEuOBSVod0UaNUIVDoeFbN/YU40yCk5HbtIrQ3ryVyS6cUlwQnFxaIdTaZLpq+UKWh04obG0LvtGxbRSpnus/viS6Yx2UfIhbNDHRRK2S8DZqh0PyMoY6GO9mhrnFSZfo2JjEiEVti6/U7SPTgOcmxN8ncVCvBOLXYdW6Oo1s2/wAEquyjuHHaRw2VsUE5SFFpS4L2j6jVH012vgo8Da9NJ45zotLZzZAQlyykJi3Q6YkPCv01LKWkXJnb0ZdRl8ilyyLTHB0yMuD4WNWhkeDt5HdouzsHKNE5Qpkoy09Dl0qGpM+ceStY0xcG8I1hnI2ucfIlsaVmsWsIu0J6Pdv07x2wbH3NWOT0dRQcfB1Ytti8ck0Sd2hR0y1lbFtLR7d7L847k2PupsUl7iLlvgqDFBX8iKKzrNcmjRrCWz8CaZsZatGtjqmMZ4RSH6vdZsuDG+oRuhOJHdCW6PJSOyR5w2WnYv3L4wmxJWLqNlN9rHN9q2XSRFIXJ8iTLFejWzeFwaEt4RSNUbOfkapDUi3jWsLxixd3p92LVDj1boXd+Dsh3XoSFJ2/BFbLiRkO2cir9MW9DWFRqh060U26H1J2yMImi8K9FvZ8ZWFXp+MtaK0P4LNaNjRovg36ffn/AHHftih0/py5s6fUl+SotxOt043Y4L3I6n8RHu6aJRdSG1Q0baHZuxMpEe5uyEVbH1deD6aElilY6Ghm80jnHOdFqkLgcWd1aKY0KsJmmNDLfp9+HwfU6bOyIpLRJbiNvaF/uR0rbkrdeT6UO3pKhzds0K9lm8U/yWmiMumpSuznsTOyFjWGOt4seGl6NFY8i4FehJibsVpo3+cKxIVGmc2Wzb9K7yynQneycE7HdxJpDuiRKVSLujwOi+S1yOkWXo7moryPrdRRXB0+nGktCisaK2Pz6XhVi0XhjsT02NDrglyNu/I0/wAEruhjoq/jD2Nen369HP5FwxWbsa5xS2NfoOQo8Casbw06ZLqy7mtIh0Y+0Zazobwxmhleh4Z4RS3wUyvGjuE0UkkNY8nyLYqN+n/UHV42Uh91EnplaObEfB8jT0VeE0bPkUP4ZUMbvDwxCReUjYxmvQ65wv3zIdKsJisQo6EkJS36alZatisUVaOn1YNRlb81wv3HCpWJMpja0IVNIV8jTtlp2NcDumMcmokV0lESNWR5EeRVoWFforOsPF8I1hasuqx5sosfnFCa0e43hRWxDbY0ya6adcsnHoykvCIv+FUV4Lg0f8Sa5Ksp7NCbod2xspDRSL6yK0PZvYkjQ/RvLxo5xdjeErbIp2hO0dxscWJrTLRQqx0oL3uir7ETk22SJsnNX4J2OTPdtn+nSql/kjHozS26f+LH9NmnhNFPRQ09vH4FYk0bpjukVcmW2Uz5GkW9mrH6EbNbxS0fOKxvD3RRb+DS8jl5GtUeTVnT6UfdtnUlqOkbsZ8ErpFbT3i0eVjlfJLvnGvDF04tYb4PktMst0Vo5Qhlcl7HDp/+/wCz6mkJujZSvHhl58ejb9GjXAqZYkn8GrexXSKR7hViMLjDnybbfI3VEnoaNfqKiKtpFI1yLFaRUrQunN0Nu0eUXZ48jq2UaLZVusdujao9tWONyrRTUlyKOnlF4dmy/UzyISI0WLhEkP8AYXfb4FLgVfTh+7KTHJ1RqcfyKPjZrbOzCfjHnKE+TSnH9y7OWxmynRY+C+GJlq6P7jtIqVJFQS+BNVLgtWiS0xGxrk0M1aJJDY15Gaz7XR5s0y5YSRTbwkTjcYL9WNmxHbKVca/wIpZWfk8ZU04y4JdKVM0RGXyh6O7SPJZWi+ChyffLwVnW0O/aeBPPyWJCOSyhNY2Jsfhn9xnlDjp7Z9ODn8FqO+WKdyryOLTkI97/AGFj24v9Mc+pdWNMl0ZdrxosrSKVGli7Nj6kiMFSN+iiMlTQ0tCKWGNjElZrGhiPgdUUO9Hgq2fy9NeXf9hd7srpOkRlBSizQrtioTZatmzezZrCoVHgVtfAyPVjUiXTdNFlcjLasSE0d2kSk7lpEYe1YrQqylrKltcji/csbKN0JIodmj5Fhd2OLY3yWRl1q/4ofe5VyPaKTTNY0b0OmiuRlCEssb45HJbERnHtktDTuGxTtDaJIly0ORDpre8LL4xp1h36EncfVZxSzTx4KVYrRJyk5cl9Rooqf6jRas1WNfYXoaxCX8yIt6f9yTdujpp3yzVLCqsusayvQ1G0z6sfydjqZrRa2Jqh0y+eS0fKwuT4Ico5Ql068v8AwhKz3tvLqzRaHeN4rDNHh43jQ1edHxnzhLGvTXOOSySg6Vkn07IyTTFzF2h+BRVi5eVYmKjWh06G3SRcnfjR73jwXoZWPk8DxesX6EsO8JlMse/VZqvQzRrPtdjh0VErpSJdrvhjhKlwVyy1yXHR8js8PC8FFJtj0bTz5+zeUKvRePK9TLNDzfqTwpRafAkjujTNJZfg+C8eMVD9RPgS6brnNY0OjR4+y1mjRRWKFv1NDzstel5SnJeMavCvQ2boYm2JSquB1pGtj7axyMpngpYT4FizWa1lZrfp36bWLymhmiPg1hrFNMd7NWapiRGuTY9MdNsuTlfJ7vS/Iy8OihYWzwKjeLVHyao+ChPnHOL9Pk0P7Lob4xcEyuSo4SEuB20ULt2KtG0/VdlYSLxT9KeGfPoVejWUvtM2I5GXBoUVZZIZKSaZ5LVM1rxl16dlcmvS/Q1i16nWEi8Xh40VixspVisWyt42Jrg0SQ0xpiaspN/BreNFDKL9LPLxo5NGvReH9hmsMfpfBbHisaPk3olbLiUtCtkW6Zsfaov9RNN16UkXZWNbxr0Pysu/TyJHzm16GP1V6NjeFTxRuyo0zVCbrFibbHedGsUa1misVhtYr0fAr5KF9p4fA+DWXYh+SvTTLgSVkm9GqZSbbG1wbRTvF3ZTEhZ1ix55yh4rjFirN51h41m8fGGsJ5fObSstFqho1bElQpOvJSboS0POjZXo16daPg8+imJZeVeNfYRsrnLPHpUmdLyRQkrs/8QAIhEAAgIDAQEBAQADAQAAAAAAAQIAAwQREhATBSAUMEAG/9oACAEDAQECAP5EH/FcQ2y6k2EizsWs2xFmwYsrsFn0+iv9FfsutjH/AGD/AH5JJBJVySxbpSSkMSCLAdqYDsQEEExYp/671NS1mv5LV8RSaVpNVdBpWkUCkU/EVfFaDSKhV8hUa1q4/wCu6a0F5gDBQIsE14BADBD6D6Ix/wBI/wCKyGYtPNjdmzv6rabcZXq6+q2iwW/U2rabA/0WzsuHB/6RNfPhJZBiJiDCu/Lt/K/w3waKLA1VuP8APjQXgAIEVOVUoFQf9NaEIldVaEJXYKZTLQ+ImCyV1cX1MhigALoDQXQXQh/gk3fYWfUWfT612D/YJiVmmjErx7bGsFyJVii2yitpbkrVdhLj5GLbTtH7WztbRYLPobBZ166svI9AilG/1pMAGump5dQ2JifmKrtYEy1yrSKhDjmrIxrMd8QUFEpeCaEXwBP4Njv332LRabA6WjIGQtwf+0mLbRK0edV4xuS18i6w4xNOFYtdYlc1diXUmooxNfArCCtlVOT7Y/fQO+g/YsDi36fXGcH+6jg3VGxVFjStFqRiihVuC3rk1XhlGbW5uOwd7m4CYfbFKBNFFTgIE5ClOccJ/oxqqKnyqf2emlNbJbZWLHRdXA4NdYUwTKT55CEllbpW6LqVPtjhg5JYWd99K21O6CPR/Fa41BpyLfzsbGcqEsjKksU11oxLFqCxQuLsQi2h6xWEFQRq1rCe3JyBGUJoQRYCHD45H8jykYs/UyUxceusIpPFOImMmOafjZQ1XNQsFbVTIrbCyKyoC+a1XVbD6wCqpUxUK8mvjng14oUf1RKFvuw7fqXpatacYEWCwWi0yyq6pZYySs7avLqsAZWDdKz2k+23fQP0X6D9hw4dWLUMP7qbJtWV2UBRTKilj2dh1DPXYDcrMxVEAgmVj5DQeDxjv22o1hQhXgryVChQpmKq+bH8CZF6ymjHrWVyqB3JEDmI1YtDIUKLBBMi60iAweH0AK53rosGDQHiCAUQf6FFVVCKoFYrZj0TtAkRai5cBiQEGv2Mt2in+AoRUrruAO4SIIhB6Ldd40H9rMPHGHXj/LgJvZsgCqZUNWQMVglYJzbdwDXgCTkLqxAutcc86ClShQpjAfyPBMKyrNqNxqV6bItnBrSLNVeWAAiV+fo2glQoUIE0BWAAALXD9Fzb9BYLfoHDBuseD+R7+ffXjVV2244pl+R9PqtjKQsUYzWAx5pPP37TOgylZswSuJAoFiL4Q66CBQAFm+sSCH3WvKL8X9PKzsOhJW71f4lAfGKl4GxXeclCiDn9u4P0rl1s+hsDVmqBQlhnJDQQzkCAaVcWD0RVFfCrT+fXg4+OtSxX7L9LecgwCYrOqUihFNf6GTl3+AaUTQlcpmxLGB30zl1foWfRXVgcWD0Svxhg4eLjfrrj0EVg0PA7MYhEB3SyF8nIyMN7R+8xr+RrWsV8Cs1rUlaCCWrzrToUFQUIEWsIFxB6JX5jrj10V5SY7f4pw/hlVMFMBQwxS12BM2n8WXW/pZKzY8Wa1oBAngjuG2S1oIdG7BB2WxD6InmM+EuRkXX4j1ZgzP8AJJdPnoxIpIJc0W2Jit+lnNZ2LOxYHRwxcWV2I8EsWN44MEAizrsnBHoizYP5eSZeMfFTFfG1Xbak3oRYQwUXZjPm5l94XkIFVQFQKVCotY8ZdQh0CrWByF44+eF/AiDz8q/IyMqnHyMb9er9avKZQrr6ohnBXr9TNAChdABQoAUgKoQeW2CzssziwWdd/QCuoVY6+rEm5h25DflMLq/yF/KGCwaw+CbDGKAcrLzv0CwYHYYEQRZ0W6UqfLVV9lXTnjkoqIqKVr/hYCDoMtuBkC9bTlNduwVjwDwDMzsjM6gg8BEWbDAwFIngmS5tW0Za3qd7A2hS02Un0TWwXFbY1tVi2K06ggUzQgXMzb7/AJqgrCCvgLyqlQETjhERfLclrOvsbkzUzUv76Uhw2JB6I0QiM2PMOgSshj5tYQVC8mfpWgaCqAvAT5BOBXwq6ihIfOeAj1MpUhGXIXL/AM05i5X5mSj+CWxIla0HBwMkogAUcqgQIQfLjeyCCKUfrvvsP9A4cttWQnwkwMS7ljcG2WUhhZ+U9Ii1DH/x1QP+fX+8mIUyarBAoHQcsIJvOcUio1LUqfMqRCKxyqqorCqiJxwQRoi4cLSBsRRi/nY//lsb84M965n+ecv7pZ+XP/RjGAlbVOtoboEkeA/owHawVsqjkroKEWv5JXzwBXACugrCWAF7IJhflYn4AjO+T9WOlgIIbDu/ebEUABCrhhB4IDuy3JwigsRiwmz5pYGErYjZIYP2YSZti8d/p+P+CBZeco3qB4T0GEER7bMZFHKwFYo0YBCbRkv88jEqHBQpzorWnCKFHnIXUIEK6KNW1H434bXtkEqoKkHYM2pMU/l3VgRYCiD+NxiVtKxQ+Kqipq/mKxUKlq45C6AHhgg81oDAw7rC5CkEmvweiCKVldmLkrFMrIBggIhYxyIsSK9lDAwwQMD9Ow4IO1bZJWc+VVBgUDRIfEP8CGKVgmLfjXBgFKsDBNlgz27Qp4s3bimElu+w2w3XQdZyf5xVdROzEMMBHm5qIQViHFyMbIUqFUDRGnsstgIgm1Ibt1upZtgibEBMQp5szZPWKNEPDF8ME3vzcB2hERqrMT9Gu9LSdtlXZoOxEgKwzfRYuHsocA7DAgggqYV0RpVrUQ+AeMIpJHgh8EWApEiGq2rNXObK6B62pDKQxZW7676V7JfUHVw4cOGQq4hmlFS1gHQBE0fFPomvBEixIgSCCA7EDb2pB31N732hsZTkUCBlgKMsAK6gNYh8Ah8bxZoeAbAEEWALEKRQIIDuCAghg2wSd9FkZ2Vna6pQoSIIPNaRaUaaEHnOmhCmAL6IFEUJAFisrAjwFYZsNAegxOwxIYsp6gHiQEzWiqhBNTQHjTUAA1rQiQBQgAULFikEQBZvYOwS2yet76ihWUgsyOpHpGqkCjzQAmoQ3i/wIFEQKBFmhBAB4JuDzYJIPXXW9ib2pdnes1ubOvBKVImx/GjDGiegKFAAgVQoEAUjwQHYIm4CW62TsNFYN0puf71PXAfaFrBAAmpqa1pxFgGgEUAABQoXwQegb3Cdg7B62CID4YsyYrVNW4beucZFEAA14YBCGEXwABQB4sEHhimAjwTe9763skQHfQm44BoellmoFRYPBNAeCHxhqDxYvogI8X0QMCD11ve973seCCKYSJkih8cqASa1AMHgg9IhEI5CrAABDFM2DB6DvfU31snr3anfi+CfprjHFPRIStRNaA80o8M0RqKqwDwTUWL4DND0kknfm4DpR6vgn664hxX+psUqB4JrwD+NGBdcAgGD0TYggIJIm9783NgmCAjxTtYID+vK2ryP8xMiqtW8AgA8Hg80AIRrQhEAE3B5sEkGEhtiEzWwdjzcWdAhv2iFCrMQf//EADERAAICAgEDBAEDAwQCAwAAAAABAhEQITEDEiAiMEFRBBNAYTJx8BSBkcEFoULR4f/aAAgBAwEDPwD9whLQiImhESJFESIm7N4payls2JbEJCKYrxEX72qL2SodtjrLL0xsZemUfeNWX4NDrF4ex41+8brLHQ0WiSdMZod4d4Z6WMvD8Hh5r95oVeCwn4fTF8ivWVmhMot4sWEX+8ShbHIa9UhK3Q02hku3aJLZolY2Scu1kq0ThdjGkO6HhjLGMY8MdfvO+r4IQeicnocI6R3u5EPpEH6Wjp1TJxJxZ1foXTgnLlk/jQ5SVkIrtopcjKQ2MkMbHY+RpjGOv3Vnqr6HTHJkVHZzSOm47R072x16RpSOqpdr2dS1271b1wT76fB3touypDmU2LKYlsRRE3leMih7SJ/ZIkiX2TPt+8pbGptP7LhsUYOXb/sUqkr/AOiS5Zs/U10onUj/AFKjot/ptkH1FLaaG4/5shFvdEOo+2r/AJ+SXapa2KMHKJJumj02ODWVRsSFeEJCoRa8aKNH1jWKLXupj6jTasqCSNkpypEbr5FKVy4On0VUI0j8ifxo6nQ2lYuovVHZK6SolOCgxLUdIbn29JNv7HGNOX+f9kP/AJKyMouizehQjbHLgaVs37fKxo1RSE9oSYi2JMQtiIvj2XDqC5FWhfB6WyMH3SdsvgtbEkdSfoirJ9JW2daX9I0rm9knSRGEFobe+RzlUuBONM5l09Cjyy0RgrHIQkjQjYsV4NFrY2SNFLFD+RDLTGNl+x/yJLtkhR5Iy3FnZC3yaY20kWqfB04epOx7oUkRu+2hdvJN+qG/o/I6cn3yVnWkv6LR3JUs9ktLkr5LVi8rQvG7P4PnGuBUI5HzhDY6w69j5JP+kj+LBuT39DlK2fq9O0NRpjTsj1GpS/pX/sfyemySjSJdxJr9Ncvn+ERj0nCv7E07ujtW5NshHaReHLp6JVsk1iQ8NMeGXfhSEuRMtio5sQti5XgvZuVFVFi6ULlLQ+tNv4FJty4LpVoVm6+BuVI7p1ZekSeiUFUOX/6FCPav9xUiuWJ7G5V8CUUWOcGkdSKqxzbjQkxrDo5yyl4N3hrWJDpjTG3wMaHYyi/YbmqKXc2PsXRTu+Sr09HUfPB+nHfJasfBGEedkm7eLY4l8DbGuRXRWhOLGniMum0P9NU9kovY81ixVYr8NbO7jG6NY22feEWqL4Pk0UvNKVsUYJn6vXlP+RS03s6fTO9tlEZOxOVtEUhEUrI/Ioie0JlFIqD+82fKKm/pnbheFKl46Huh1l7oaw63hWIRfsVJM7Px3X0bHeh8vFMooVloZoVvHpLdlDrYmisy6kHR3TfhrztDvFO3hpHyimMZvgaw6Nex3fjQXy/+sSkdq3hXbNUitieKPg5zoWGNWPH6PTtj7nebF5oiUxI0LOsp0c+1KSofyRRopDs7SMlaN0aNDoWyyl4aH3WWytsua6f0J+FmsvCrYyxFjPTseGhp7G3jQ3s17EJJVyRit2Jq0ek3ooSVjQmMsSEsVHCeipYtaKEPqdaUn9j89+GmKOvk+RPFq0Jf3FsVi4KHil7MV041TZ0VpnTbtEYcikOhwW0RaoiOnQ094ZUhONmtmxUXbKsY+j+LKXzwhjPoY8Usbwx4p7KKFjloT4N4+eRPOvYSqEOfkg+RdKHpP1ppLhDZR01yiE/6B1wRfJCa0OOjbNF9Oi2K8VGikaK6UICKWEbFlWIQhm9ja0MY3oaeGPFY17L6U+6J39O4rZLtpvk7YqyhMUrs7G3CRJKpbQpJuHJOLL8m3ZqsfZ3fktP4ELZZTyhMSYmhCrNPRTEy0JWc55wma8nhs6vV4R/pOk+pJnW/M61/AoQUbso7VY7I7UtEUtMa2md0coSkWORrZ0eo+2L2ODaYuh02z/Uep/1LD89+DLHVDGh4dDFwyxlI1fjo0emj5YlFCn1el+P97ZHpxqJvaFuy+BxZYnhDzTI9uxKHo/xEnGovTP1I9rGpyi/g9CiL4KflrFPx1n68Kw0NYfb46wpTin9irgcVZ05zUmtohIhJanZJCjDZ3bGmPGi3YrKKHaT4FG38M/S6rXS4O+UrO+c5/bH1uo19Py34b8EeopiQirsWPrCERs146x29VMToklRJt0SSsk4kkuRyXJ3xaN1i0b1h8Gxlsl04og4980Pp9KclzLRDowpFux14Px2XnmsNYtWa5NjQ7L5GNn8mr8dY3ZcYtkJTakdKG+BThaehJUSS0Si6ZSO6PejQyys0j1JvgUpLsidTqq+pLR+h0H1Pn4J9W22N84Y6p+bvwVCTdHwxcEWLdCEynZoti2KrNV46zpxO2akP/wAh0VLoO2uUfkfip02mdeTUW7IT61duj8brycWj8flSo7Dtk0Xhb8Jdv9sdq7+pwf6jqa4RZQsWJYoWEK/GtjL2abxeKxbLQivGkKjR2dRHcT6O4rTOh1329RWfgt9y0fiQdxkdHpp1I6MXxY3yXKylRQ+3wXZT5Z0fxkm+SfW6sn8cYXIihCQhZVCFfg6PsvgaGkaxS0WxvRRrQ0a8dYb2drIzeh9O0Qb2jpfQvhHUkqKWxUc5WfVRDoQlP5X+I6vVn3Tdsb5w6H5NeG/Bm9CXLxFiptCYqEUxMSEW/H05Y1GLQ5K1myiyyhvRRbyvxk5Xsn153N+GvLYvBeFje0N3L6H8lMlETIy4ZeGMZ6fGoCee5OJ2wEh4eHwhvkbXhSZ39dr4WEUKrwq8KzWd+H3h3QnE0W2aGrJbJ8fRKibJ6sbjRfgu02MlJ0dD8Sp/k2n8Jc//AIiHWi0tMeENmzWYi+MUmxy6jdY2NFGix5bGM0OvLfOK0PaEsL4JMaFyiyymNqx1iUh/LIvkglpEXNu/gjP8npxf2iX+rlN/I1O0Nc7OnIi+RC5WNY7tIp4rosvYrNGsay7xZTwzWdZvaLHo3i4DT2JaLY+4+j8n8htdKNr/AD5LV9af/B+P0IpRRCCIRK4HWiVbJyR6tjf5XTt0rRTj/uerDQ3j6PhDrP1hySSFwRYqEL2nQ0bELKsfGFVIq9Fop0fDPyPypXFa+z8bpb6nqf8APH/AoRpcERtCcdDNMpGsqE+nL6aO/tf85+isVj5xvMo9W47+19ibbWvol05VJbKHWy8awtFYrNLGxFGxpjSw0M0PH6iXV/I4+F9kYQSjwRjpn0yXbstbEmXz5NH6/wCPGX8lRH4WPG+cXhXZaj/ZEepDtZ2TbhtfBSw0vFrHJRa8uaNEmWJrY6JWzf6/X4+F/wDZRJrQ57kVyV7Otlxl0pCWj4QqxeEfx4aZ3aPW1hStSHHjaE9rxoVCFlG8RrgViStiORMWOi5d3U/4EkfqaFEW8I341fg4NSjyQ60e5PxQvBUaF04OXy+PCmRntcjhqWFisUXlG7xeEyhVeG9lyouSTH22hrY2aGUipYpZd3ileZdGVoh1Y90X7FGtiS7pcEuo7ZaEfZ847lUlaPmGKeKGXjQqFeyzWFYqNUL5PoVnr8EtI2aNmil5OjQnon0JXEh1Y2hLWLEiyhkIcsc8fZT8odS7JQKdMsQ8WI9WKOc3YkrLGtj72V4bxvx1nVGqGniUHcdMhLU9MiQaELg6fTZOfGi/cUlcRxeHi8cmhYfNjrNsXa0h4tYovZo37VrwnFaY0vViUh8sY8a8Hm0UsqV2SitFcl2IsXg7w1jkdHpxrOzWHXgvHWFXsO/Klll4SePhleqPByaxvLN+HclQ9eC/YsWdY0Xl5teNI2IuRS0J3KJeN28JYsZSKH27Yq8XmhrFZ3h+KwvGl4orw0Mo2U7G+cteFirQqsXGHW8K/B4a9ih3o3YuCil7NY0J4+s758L28csd8lMdCb8tG1inn7KQqwqN1h2WVx4r2te66NnwaxRodmjY87K1l+08XZXhr39e0tvFQFQpNnyPZbaKLG58C3jXlZ8ZodF5+fC9+C9vXks0Oh/pMsp6whLFjSbXJrfgsfHk/CvF+0l4XleVZuDQ0Ox2KhvWddud+DxS91vN/sK8/k7OrKP8iT0NsqObavNeFe1soSWKXjsXi/YteCrO81+Q2evRoqOWsLCXlrz141415c+zrxpXlfqRf8CXU0IiJ8GzQtv3Xmvasr2KQ8usWVisUs7g/wC41IUVZfD0Nsb2Wt5XsKs78NftK9jfg+2DX8nU+TqcE09l8n//2Q==";
var JeroenAvatar = memo28(
  (props) => {
    const className = cx15("rounded-full");
    return /* @__PURE__ */ jsx28(
      Image,
      {
        className,
        src: AVATAR_BASE64,
        alt: "Jeroen Riemens",
        width: props.size === "large" ? 48 : 32,
        height: props.size === "large" ? 48 : 32
      }
    );
  }
);
JeroenAvatar.displayName = "JeroenAvatar";

// src/layout/Flex.tsx
import { memo as memo29 } from "react";
import { cx as cx16 } from "utils";
import { jsx as jsx29 } from "react/jsx-runtime";
var Flex = memo29((props) => {
  return /* @__PURE__ */ jsx29(
    "div",
    {
      className: cx16(
        "flex items-start",
        props.center && "items-center justify-center",
        props.gap !== false && (props.col ? props.gap ? "space-y-3" : "space-y-1" : props.gap ? "space-x-3" : "space-x-1"),
        props.col ? "flex-col" : !props.center && "items-center",
        props.full && "h-full",
        props.maxWidth === true && "mx-auto w-full max-w-lg",
        props.maxWidth === "large" && "mx-auto w-full max-w-3xl",
        props.padding === true && "px-6 py-3",
        props.padding === "large" && "px-6 py-8"
      ),
      children: props.children
    }
  );
});
Flex.displayName = "Flex";

// src/layout/Footer.tsx
import { memo as memo30 } from "react";
import { jsx as jsx30 } from "react/jsx-runtime";
var Footer = memo30((props) => {
  const className = "flex flex-col items-center justify-center";
  return /* @__PURE__ */ jsx30("div", { className: "px-6 pb-6 pt-16", children: /* @__PURE__ */ jsx30("div", { className, children: /* @__PURE__ */ jsx30("div", { className: "flex max-w-lg flex-col items-center justify-center space-y-3 text-center", children: props.children }) }) });
});
Footer.displayName = "Footer";

// src/layout/Gap.tsx
import { memo as memo31 } from "react";
import { jsx as jsx31 } from "react/jsx-runtime";
var Gap = memo31((props) => {
  return /* @__PURE__ */ jsx31(
    "div",
    {
      className: props.flex ? "flex-1" : "h-3 flex-shrink-0",
      role: "presentation"
    }
  );
});
Gap.displayName = "Gap";

// src/layout/Hero.tsx
import { memo as memo32 } from "react";
import { jsx as jsx32 } from "react/jsx-runtime";
var Hero = memo32((props) => {
  const className = "flex flex-col items-center justify-center";
  return /* @__PURE__ */ jsx32("div", { className: "w-full px-6 pt-20 pb-16", children: /* @__PURE__ */ jsx32("div", { className, children: /* @__PURE__ */ jsx32("div", { className: "flex w-full max-w-lg flex-col items-center justify-center space-y-3 text-center", children: props.children }) }) });
});
Hero.displayName = "Hero";

// src/layout/Page.tsx
import Head from "next/head";
import { memo as memo35, useContext } from "react";
import { Shortcuts as Shortcuts2, getHeadTitle, cx as cx17 } from "utils";

// src/templates/ErrorTemplate.tsx
import Link2 from "next/link";
import { memo as memo33 } from "react";
import { getErrorMessage } from "utils";
import { Fragment as Fragment5, jsx as jsx33, jsxs as jsxs12 } from "react/jsx-runtime";
var ErrorTemplate = memo33(
  (props) => {
    return /* @__PURE__ */ jsx33(Fragment5, { children: /* @__PURE__ */ jsxs12(Flex, { center: true, col: true, padding: true, full: true, children: [
      /* @__PURE__ */ jsx33(Icon, { type: "warning", color: "red", big: true }),
      /* @__PURE__ */ jsx33(Gap, {}),
      /* @__PURE__ */ jsx33(Title, { children: props.errorMessage || getErrorMessage(props.errorType) }),
      props.actions ? /* @__PURE__ */ jsxs12(Fragment5, { children: [
        /* @__PURE__ */ jsx33(Gap, {}),
        /* @__PURE__ */ jsx33(Gap, {}),
        /* @__PURE__ */ jsx33(Flex, { gap: true, center: true, children: Object.entries(props.actions).map(([id, action]) => /* @__PURE__ */ jsx33(Button, { action }, id)) })
      ] }) : /* @__PURE__ */ jsxs12(Text, { children: [
        "If you believe this is an error, please",
        " ",
        /* @__PURE__ */ jsx33(Link2, { href: "/support", className: "border-b", children: "contact us" }),
        "."
      ] })
    ] }) });
  }
);
ErrorTemplate.displayName = "ErrorTemplate";

// src/context/ProjectRoot.tsx
import { createContext, memo as memo34 } from "react";
import { Provider as Provider2 } from "react-wrap-balancer";
import { Analytics } from "@vercel/analytics/react";
import { jsx as jsx34, jsxs as jsxs13 } from "react/jsx-runtime";
var ProjectContext = createContext({
  description: "",
  title: ""
});
var ProjectRoot = memo34(
  (props) => {
    return /* @__PURE__ */ jsxs13(
      ProjectContext.Provider,
      {
        value: {
          description: props.description,
          title: props.title
        },
        children: [
          /* @__PURE__ */ jsx34(Provider2, { children: props.children }),
          /* @__PURE__ */ jsx34(Analytics, {})
        ]
      }
    );
  }
);
ProjectRoot.displayName = "ProjectRoot";

// src/layout/Page.tsx
import { Fragment as Fragment6, jsx as jsx35, jsxs as jsxs14 } from "react/jsx-runtime";
var Page = memo35((props) => {
  var _a, _b;
  const isError = (_a = props.statuses) == null ? void 0 : _a.some((status) => status === "error");
  const isLoading = (_b = props.statuses) == null ? void 0 : _b.some((status) => status === "loading");
  const className = cx17(
    "flex h-full flex-1 flex-col overflow-scroll",
    props.surface && "bg-surface"
  );
  const main = /* @__PURE__ */ jsx35("main", { className, children: isError ? /* @__PURE__ */ jsx35(ErrorTemplate, { errorMessage: "You do not have access to this space." }) : (
    // Mute the spinner so it doesn't briefly flash when the page loads.
    isLoading ? /* @__PURE__ */ jsx35(Flex, { full: true, center: true, children: /* @__PURE__ */ jsx35(Spinner, { muted: true }) }) : props.children
  ) });
  const project = useContext(ProjectContext);
  return /* @__PURE__ */ jsxs14(Fragment6, { children: [
    /* @__PURE__ */ jsx35(Head, { children: /* @__PURE__ */ jsx35("title", { children: getHeadTitle(project.title, project.description, props.docTitle) }) }),
    !isError && /* @__PURE__ */ jsx35(Shortcuts2, { actions: props.actions }),
    props.sidebar && !isError && !isLoading ? /* @__PURE__ */ jsxs14(Flex, { full: true, gap: false, children: [
      props.sidebar,
      main
    ] }) : main
  ] });
});
Page.displayName = "Page";

// src/logo/WebbieLogo.tsx
import { memo as memo36 } from "react";
import { jsx as jsx36 } from "react/jsx-runtime";
var WebbieLogo = memo36(() => {
  return /* @__PURE__ */ jsx36("div", { className: "bg-elevated text-high flex h-9 w-9 flex-shrink-0 items-center justify-center rounded pt-0.5 font-mono font-bold shadow-sm dark:bg-black", children: "W" });
});
WebbieLogo.displayName = "WebbieLogo";

// src/sidebar/Sidebar.tsx
import { Root as Root5 } from "@radix-ui/react-toolbar";
import { forwardRef as forwardRef6, memo as memo37 } from "react";
import { jsx as jsx37 } from "react/jsx-runtime";
var SidebarFn = forwardRef6(
  (props, ref) => {
    return /* @__PURE__ */ jsx37("aside", { className: "flex h-full w-72 flex-col overflow-scroll", children: /* @__PURE__ */ jsx37(
      Root5,
      {
        loop: false,
        orientation: "vertical",
        ref,
        className: "focus-ring-none",
        children: props.children
      }
    ) });
  }
);
SidebarFn.displayName = "Sidebar";
var Sidebar = memo37(SidebarFn);

// src/sidebar/SidebarBack.tsx
import { memo as memo38 } from "react";
import { cx as cx18 } from "utils";
import { jsx as jsx38, jsxs as jsxs15 } from "react/jsx-runtime";
var SidebarBack = memo38(
  (props) => {
    const className = cx18(
      "pt-1 pb-3 px-3 border-b mb-3 flex items-center space-x-3"
    );
    return /* @__PURE__ */ jsxs15("div", { className, children: [
      /* @__PURE__ */ jsx38("div", { className: "text-med hover:bg-elevated mr-auto flex h-7 items-center truncate rounded py-1 px-1 text-sm font-semibold active:brightness-95", children: props.children }),
      props.button
    ] });
  }
);
SidebarBack.displayName = "SidebarBack";

// src/sidebar/SidebarGroup.tsx
import { memo as memo39 } from "react";
import { jsx as jsx39, jsxs as jsxs16 } from "react/jsx-runtime";
var SidebarGroup = memo39(
  (props) => {
    return /* @__PURE__ */ jsxs16("div", { children: [
      /* @__PURE__ */ jsx39("div", { className: "text-med px-5 pt-3 pb-2 text-xs font-medium", children: props.title }),
      props.children
    ] });
  }
);
SidebarGroup.displayName = "SidebarGroup";

// src/sidebar/SidebarItem.tsx
import { Button as Button2 } from "@radix-ui/react-toolbar";
import { memo as memo40 } from "react";
import { cx as cx19 } from "utils";
import { jsx as jsx40, jsxs as jsxs17 } from "react/jsx-runtime";
var SidebarItem = memo40(
  (_a) => {
    var _b = _a, { onClick } = _b, props = __objRest(_b, ["onClick"]);
    var _a2;
    const className = cx19(
      "h-9 px-4 flex w-full items-center space-x-2.5 focus-ring-none",
      props.focus && "bg-surface",
      props.active ? "bg-elevated" : "focus:bg-surface active:bg-surface"
    );
    return /* @__PURE__ */ jsx40(Button2, { tabIndex: -1, asChild: true, children: /* @__PURE__ */ jsxs17(HeadlessButton, { onClick, className, children: [
      ((_a2 = props.iconDetails) == null ? void 0 : _a2.icon) && /* @__PURE__ */ jsx40(Icon, { small: true, type: props.iconDetails.icon }),
      /* @__PURE__ */ jsx40(
        "span",
        {
          className: cx19(
            "text-sm font-medium",
            !props.children && "text-low",
            props.active ? "text-high" : "text-med"
          ),
          children: props.children || "Untitled"
        }
      )
    ] }) });
  }
);
SidebarItem.displayName = "SidebarItem";

// src/surface/Surface.tsx
import Head2 from "next/head";
import { memo as memo41, useContext as useContext2 } from "react";
import { Shortcuts as Shortcuts3, getHeadTitle as getHeadTitle2 } from "utils";
import { jsx as jsx41, jsxs as jsxs18 } from "react/jsx-runtime";
var Surface = memo41((props) => {
  var _a, _b;
  const isError = (_a = props.statuses) == null ? void 0 : _a.some((status) => status === "error");
  const isLoading = (_b = props.statuses) == null ? void 0 : _b.some((status) => status === "loading");
  const project = useContext2(ProjectContext);
  return /* @__PURE__ */ jsxs18("div", { className: "bg-surface flex h-full flex-1 flex-col border-l", children: [
    props.docTitle && /* @__PURE__ */ jsx41(Head2, { children: /* @__PURE__ */ jsx41("title", { children: getHeadTitle2(project.title, project.description, props.docTitle) }) }),
    !isError && /* @__PURE__ */ jsx41(Shortcuts3, { actions: props.actions }),
    isError ? /* @__PURE__ */ jsx41(ErrorTemplate, { errorMessage: "You do not have access to this document." }) : (
      // Mute the spinner so it doesn't briefly flash when the page loads.
      isLoading ? /* @__PURE__ */ jsx41(Flex, { full: true, center: true, children: /* @__PURE__ */ jsx41(Spinner, { muted: true }) }) : props.children
    )
  ] });
});
Surface.displayName = "Surface";

// src/surface/SurfaceContent.tsx
import { memo as memo42 } from "react";
import { jsx as jsx42 } from "react/jsx-runtime";
var SurfaceContent = memo42(
  (props) => {
    return /* @__PURE__ */ jsx42("div", { className: "flex-1 overflow-scroll", children: props.children });
  }
);
SurfaceContent.displayName = "SurfaceContent";

// src/surface/SurfaceFooter.tsx
import { memo as memo43 } from "react";
import { jsx as jsx43 } from "react/jsx-runtime";
var SurfaceFooter = memo43(
  (props) => {
    return /* @__PURE__ */ jsx43("div", { className: "flex h-12 items-center border-t p-3", children: /* @__PURE__ */ jsx43(Flex, { gap: true, children: props.children }) });
  }
);
SurfaceFooter.displayName = "SurfaceHeader";

// src/surface/SurfaceHeader.tsx
import { memo as memo44 } from "react";
import { jsx as jsx44 } from "react/jsx-runtime";
var SurfaceHeader = memo44(
  (props) => {
    return /* @__PURE__ */ jsx44("div", { className: "border-b p-3", children: /* @__PURE__ */ jsx44(Flex, { gap: true, children: props.children }) });
  }
);
SurfaceHeader.displayName = "SurfaceHeader";

// src/table/Table.tsx
import { memo as memo45 } from "react";
import { cx as cx20 } from "utils";
import { jsx as jsx45 } from "react/jsx-runtime";
var Table = memo45((props) => {
  const className = cx20(
    "grid overflow-hidden rounded-xl border grid-cols-1",
    props.cols === 2 && "sm:grid-cols-2",
    props.cols === 3 && "sm:grid-cols-3",
    props.cols === 4 && "sm:grid-cols-4",
    props.cols === 5 && "sm:grid-cols-5",
    props.cols === 6 && "sm:grid-cols-6"
  );
  return /* @__PURE__ */ jsx45("div", { className, children: props.children });
});
Table.displayName = "Table";

// src/table/TableCell.tsx
import { memo as memo46 } from "react";
import { cx as cx21 } from "utils";
import { jsx as jsx46 } from "react/jsx-runtime";
var TableCell = memo46(
  (props) => {
    const className = cx21(
      `flex flex-col items-start relative p-2`,
      props.maxHeight && "overflow-y-auto max-h-[18rem]",
      !props.left && "sm:border-l",
      !props.bottom && "sm:border-b",
      !props.last && "border-b",
      !props.last && props.bottom && "sm:border-b-0",
      props.order === 1 && "sm:order-1",
      props.order === 2 && "sm:order-2",
      props.order === 3 && "sm:order-3",
      props.order === 4 && "sm:order-4",
      props.order === 5 && "sm:order-5",
      props.order === 6 && "sm:order-6"
    );
    return /* @__PURE__ */ jsx46("div", { className, children: props.children });
  }
);
TableCell.displayName = "TableCell";

// src/utilities/OnlyDesktop.tsx
import { memo as memo47 } from "react";
import { jsx as jsx47 } from "react/jsx-runtime";
var OnlyDesktop = memo47(
  (props) => {
    return /* @__PURE__ */ jsx47("div", { className: "hidden sm:block", children: props.children });
  }
);
OnlyDesktop.displayName = "OnlyDesktop";

// src/views/Grid.tsx
import { memo as memo49 } from "react";

// src/views/GridItem.tsx
import { memo as memo48 } from "react";
import { jsx as jsx48, jsxs as jsxs19 } from "react/jsx-runtime";
var GridItem = memo48((item) => {
  return /* @__PURE__ */ jsxs19(
    HeadlessButton,
    {
      onClick: () => item.onSelect(item.id),
      className: "bg-elevated rounded p-1 text-left shadow-sm active:brightness-[0.98] dark:active:brightness-95",
      children: [
        /* @__PURE__ */ jsx48(ImageLike, { size: "h-32 w-full", image: item.image }),
        /* @__PURE__ */ jsxs19("div", { className: "flex items-center p-2 pt-2.5", children: [
          /* @__PURE__ */ jsxs19("div", { className: "flex-1", children: [
            /* @__PURE__ */ jsx48(Title, { size: "small", children: item.title }),
            /* @__PURE__ */ jsx48(Text, { children: item.description })
          ] }),
          item.shortcutLabel && /* @__PURE__ */ jsx48(ShortcutLabel, { children: item.shortcutLabel })
        ] })
      ]
    },
    item.id
  );
});
GridItem.displayName = "GridItem";

// src/views/Grid.tsx
import { jsx as jsx49 } from "react/jsx-runtime";
var Grid = memo49((props) => {
  return /* @__PURE__ */ jsx49("div", { className: "grid grid-cols-5 gap-3 p-3", children: props.items.map((item) => /* @__PURE__ */ jsx49(GridItem, __spreadValues({}, item), item.id)) });
});
Grid.displayName = "Grid";
export {
  AlertDialog,
  Avatar,
  Badge,
  Button,
  Card,
  Code,
  ContextMenu,
  DropdownMenu,
  ErrorTemplate,
  Field,
  Flex,
  Footer,
  Form,
  Gap,
  Grid,
  GridItem,
  Hero,
  Highlight,
  Icon,
  ImageLike,
  Input,
  InputTitle,
  JeroenAvatar,
  Label,
  LeadForm,
  Link,
  NotificationBar,
  OnlyDesktop,
  Page,
  ProjectRoot,
  Sidebar,
  SidebarBack,
  SidebarGroup,
  SidebarItem,
  Spinner,
  Surface,
  SurfaceContent,
  SurfaceFooter,
  SurfaceHeader,
  Table,
  TableCell,
  Text,
  Title,
  Tooltip,
  WebbieLogo
};
